var items = {
  "block.minecraft.acacia_button": "Premendus acaciae",
  "block.minecraft.acacia_door": "Ostium acaciae",
  "block.minecraft.acacia_fence": "Saepes acaciae",
  "block.minecraft.acacia_fence_gate": "Foris acaciae",
  "block.minecraft.acacia_hanging_sign": "Titulus pendens acaciae",
  "block.minecraft.acacia_leaves": "Folia acaciae",
  "block.minecraft.acacia_log": "Truncus acaciae",
  "block.minecraft.acacia_planks": "Tabulae acaciae",
  "block.minecraft.acacia_pressure_plate": "Tabula premenda acaciae",
  "block.minecraft.acacia_sapling": "Arbuscula acaciae",
  "block.minecraft.acacia_shelf": "Pegma acaciae",
  "block.minecraft.acacia_sign": "Titulus acaciae",
  "block.minecraft.acacia_slab": "Gradus acaciae",
  "block.minecraft.acacia_stairs": "Scalae acaciae",
  "block.minecraft.acacia_trapdoor": "Ostium horizontale acaciae",
  "block.minecraft.acacia_wall_hanging_sign": "Titulus pendens muralis acaciae",
  "block.minecraft.acacia_wall_sign": "Titulus muralis acaciae",
  "block.minecraft.acacia_wood": "Lignum acaciae",
  "block.minecraft.activator_rail": "Ferrivia incitans",
  "block.minecraft.air": "Aer",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Cubus amethystinus",
  "block.minecraft.amethyst_cluster": "Coacervatio amethystorum",
  "block.minecraft.ancient_debris": "Antiqua sedimina",
  "block.minecraft.andesite": "Andesites",
  "block.minecraft.andesite_slab": "Gradus andesitae",
  "block.minecraft.andesite_stairs": "Scalae andesitae",
  "block.minecraft.andesite_wall": "Murus andesitae",
  "block.minecraft.anvil": "Incus",
  "block.minecraft.attached_melon_stem": "Caulis peponis adiunctus",
  "block.minecraft.attached_pumpkin_stem": "Caulis cucurbitae adiunctus",
  "block.minecraft.azalea": "Rhododendron",
  "block.minecraft.azalea_leaves": "Folia rhododendri",
  "block.minecraft.azure_bluet": "Houstonia caerulea",
  "block.minecraft.bamboo": "Harundo Indica",
  "block.minecraft.bamboo_block": "Cubus harundinum Indicarum",
  "block.minecraft.bamboo_button": "Premendum harundinum Indicarum",
  "block.minecraft.bamboo_door": "Ostium harundinum Indicarum",
  "block.minecraft.bamboo_fence": "Saepes harundinum Indicarum",
  "block.minecraft.bamboo_fence_gate": "Foris harundinum Indicarum",
  "block.minecraft.bamboo_hanging_sign": "Titulus pendens harundinum Indicarum",
  "block.minecraft.bamboo_mosaic": "Pavimentum harundinum Indicarum",
  "block.minecraft.bamboo_mosaic_slab": "Gradus pavimenti harundinum Indicarum",
  "block.minecraft.bamboo_mosaic_stairs": "Scalae pavimenti harundinum Indicarum",
  "block.minecraft.bamboo_planks": "Tabulae harundinum Indicarum",
  "block.minecraft.bamboo_pressure_plate": "Tabula premenda harundinum Indicarum",
  "block.minecraft.bamboo_sapling": "Pampinus harundinis Indicae",
  "block.minecraft.bamboo_shelf": "Pegma harundinum Indicarum",
  "block.minecraft.bamboo_sign": "Titulus harundinum Indicarum",
  "block.minecraft.bamboo_slab": "Gradus harundinum Indicarum",
  "block.minecraft.bamboo_stairs": "Scalae harundinum Indicarum",
  "block.minecraft.bamboo_trapdoor": "Ostium horizontale harundinum Indicarum",
  "block.minecraft.bamboo_wall_hanging_sign": "Titulus pendens muralis harundinum Indicarum",
  "block.minecraft.bamboo_wall_sign": "Titulus muralis harundinum Indicarum",
  "block.minecraft.banner.base.black": "Campus totus niger",
  "block.minecraft.banner.base.blue": "Campus totus caeruleus",
  "block.minecraft.banner.base.brown": "Campus totus brunneus",
  "block.minecraft.banner.base.cyan": "Campus totus cyaneus",
  "block.minecraft.banner.base.gray": "Campus totus cinereus",
  "block.minecraft.banner.base.green": "Campus totus viridis",
  "block.minecraft.banner.base.light_blue": "Campus totus aerius",
  "block.minecraft.banner.base.light_gray": "Campus totus canus",
  "block.minecraft.banner.base.lime": "Campus totus prasinus",
  "block.minecraft.banner.base.magenta": "Campus totus rubropurpureus",
  "block.minecraft.banner.base.orange": "Campus totus aurantius",
  "block.minecraft.banner.base.pink": "Campus totus roseus",
  "block.minecraft.banner.base.purple": "Campus totus purpureus",
  "block.minecraft.banner.base.red": "Campus totus ruber",
  "block.minecraft.banner.base.white": "Campus totus albus",
  "block.minecraft.banner.base.yellow": "Campus totus flavus",
  "block.minecraft.banner.border.black": "Ora nigra",
  "block.minecraft.banner.border.blue": "Ora caerulea",
  "block.minecraft.banner.border.brown": "Ora brunnea",
  "block.minecraft.banner.border.cyan": "Ora cyanea",
  "block.minecraft.banner.border.gray": "Ora cinerea",
  "block.minecraft.banner.border.green": "Ora viridis",
  "block.minecraft.banner.border.light_blue": "Ora aeria",
  "block.minecraft.banner.border.light_gray": "Ora cana",
  "block.minecraft.banner.border.lime": "Ora prasina",
  "block.minecraft.banner.border.magenta": "Ora rubropurpurea",
  "block.minecraft.banner.border.orange": "Ora aurantia",
  "block.minecraft.banner.border.pink": "Ora rosea",
  "block.minecraft.banner.border.purple": "Ora purpurea",
  "block.minecraft.banner.border.red": "Ora rubra",
  "block.minecraft.banner.border.white": "Ora alba",
  "block.minecraft.banner.border.yellow": "Ora flava",
  "block.minecraft.banner.bricks.black": "Ager testaceus nigrus",
  "block.minecraft.banner.bricks.blue": "Ager testaceus caeruleus",
  "block.minecraft.banner.bricks.brown": "Ager testaceus brunneus",
  "block.minecraft.banner.bricks.cyan": "Ager testaceus cyaneus",
  "block.minecraft.banner.bricks.gray": "Ager testaceus cinereus",
  "block.minecraft.banner.bricks.green": "Ager testaceus viridis",
  "block.minecraft.banner.bricks.light_blue": "Ager testaceus aerius",
  "block.minecraft.banner.bricks.light_gray": "Ager testaceus canus",
  "block.minecraft.banner.bricks.lime": "Ager testaceus prasinus",
  "block.minecraft.banner.bricks.magenta": "Ager testaceus rubropurpureus",
  "block.minecraft.banner.bricks.orange": "Ager testaceus aurantius",
  "block.minecraft.banner.bricks.pink": "Ager testaceus roseus",
  "block.minecraft.banner.bricks.purple": "Ager testaceus purpureus",
  "block.minecraft.banner.bricks.red": "Ager testaceus ruber",
  "block.minecraft.banner.bricks.white": "Ager testaceus albus",
  "block.minecraft.banner.bricks.yellow": "Ager testaceus flavus",
  "block.minecraft.banner.circle.black": "Circlus niger",
  "block.minecraft.banner.circle.blue": "Circlus caeruleus",
  "block.minecraft.banner.circle.brown": "Circlus brunneus",
  "block.minecraft.banner.circle.cyan": "Circlus cyaneus",
  "block.minecraft.banner.circle.gray": "Circlus cinereus",
  "block.minecraft.banner.circle.green": "Circlus viridis",
  "block.minecraft.banner.circle.light_blue": "Circlus aerius",
  "block.minecraft.banner.circle.light_gray": "Circlus canus",
  "block.minecraft.banner.circle.lime": "Circlus prasinus",
  "block.minecraft.banner.circle.magenta": "Circlus rubropurpureus",
  "block.minecraft.banner.circle.orange": "Circlus aurantius",
  "block.minecraft.banner.circle.pink": "Circlus roseus",
  "block.minecraft.banner.circle.purple": "Circlus purpureus",
  "block.minecraft.banner.circle.red": "Circlus ruber",
  "block.minecraft.banner.circle.white": "Circlus albus",
  "block.minecraft.banner.circle.yellow": "Circlus flavus",
  "block.minecraft.banner.creeper.black": "Imago creeper nigra",
  "block.minecraft.banner.creeper.blue": "Imago creeper caerulea",
  "block.minecraft.banner.creeper.brown": "Imago creeper brunnea",
  "block.minecraft.banner.creeper.cyan": "Imago creeper cyanea",
  "block.minecraft.banner.creeper.gray": "Imago creeper cinerea",
  "block.minecraft.banner.creeper.green": "Imago creeper viridis",
  "block.minecraft.banner.creeper.light_blue": "Imago creeper aeria",
  "block.minecraft.banner.creeper.light_gray": "Imago creeper cana",
  "block.minecraft.banner.creeper.lime": "Imago creeper prasina",
  "block.minecraft.banner.creeper.magenta": "Imago creeper rubropurpurea",
  "block.minecraft.banner.creeper.orange": "Imago creeper aurantia",
  "block.minecraft.banner.creeper.pink": "Imago creeper rosea",
  "block.minecraft.banner.creeper.purple": "Imago creeper purpurea",
  "block.minecraft.banner.creeper.red": "Imago creeper rubra",
  "block.minecraft.banner.creeper.white": "Imago creeper alba",
  "block.minecraft.banner.creeper.yellow": "Imago creeper flava",
  "block.minecraft.banner.cross.black": "Facies decem nigra",
  "block.minecraft.banner.cross.blue": "Facies decem caerulea",
  "block.minecraft.banner.cross.brown": "Facies decem brunnea",
  "block.minecraft.banner.cross.cyan": "Facies decem cyanea",
  "block.minecraft.banner.cross.gray": "Facies decem cinerea",
  "block.minecraft.banner.cross.green": "Facies decem viridis",
  "block.minecraft.banner.cross.light_blue": "Facies decem aeria",
  "block.minecraft.banner.cross.light_gray": "Facies decem cana",
  "block.minecraft.banner.cross.lime": "Facies decem prasina",
  "block.minecraft.banner.cross.magenta": "Facies decem rubropurpurea",
  "block.minecraft.banner.cross.orange": "Facies decem aurantia",
  "block.minecraft.banner.cross.pink": "Facies decem rosea",
  "block.minecraft.banner.cross.purple": "Facies decem purpurea",
  "block.minecraft.banner.cross.red": "Facies decem rubra",
  "block.minecraft.banner.cross.white": "Facies decem alba",
  "block.minecraft.banner.cross.yellow": "Facies decem flava",
  "block.minecraft.banner.curly_border.black": "Finitio curvum nigrum",
  "block.minecraft.banner.curly_border.blue": "Finitio curvum caeruleum",
  "block.minecraft.banner.curly_border.brown": "Finitio curvum brunneum",
  "block.minecraft.banner.curly_border.cyan": "Finitio curvum cyaneum",
  "block.minecraft.banner.curly_border.gray": "Finitio curvum cinereum",
  "block.minecraft.banner.curly_border.green": "Finitio curvum viride",
  "block.minecraft.banner.curly_border.light_blue": "Finitio curvum aerium",
  "block.minecraft.banner.curly_border.light_gray": "Finitio curvum canum",
  "block.minecraft.banner.curly_border.lime": "Finitio curvum prasinum",
  "block.minecraft.banner.curly_border.magenta": "Finitio curvum rubropurpureum",
  "block.minecraft.banner.curly_border.orange": "Finitio curvum aurantium",
  "block.minecraft.banner.curly_border.pink": "Finitio curvum roseum",
  "block.minecraft.banner.curly_border.purple": "Finitio curvum purpureum",
  "block.minecraft.banner.curly_border.red": "Finitio curvum rubrum",
  "block.minecraft.banner.curly_border.white": "Finitio curvum album",
  "block.minecraft.banner.curly_border.yellow": "Finitio curvum flavum",
  "block.minecraft.banner.diagonal_left.black": "Per anfractus sinistrae niger",
  "block.minecraft.banner.diagonal_left.blue": "Per anfractus sinistrae caeruleus",
  "block.minecraft.banner.diagonal_left.brown": "Per anfractus sinistrae brunneus",
  "block.minecraft.banner.diagonal_left.cyan": "Per anfractus sinistrae cyaneus",
  "block.minecraft.banner.diagonal_left.gray": "Per anfractus sinistrae cinereus",
  "block.minecraft.banner.diagonal_left.green": "Per anfractus sinistrae viridis",
  "block.minecraft.banner.diagonal_left.light_blue": "Per anfractus sinistrae aerius",
  "block.minecraft.banner.diagonal_left.light_gray": "Per anfractus sinistrae canus",
  "block.minecraft.banner.diagonal_left.lime": "Per anfractus sinistrae prasinus",
  "block.minecraft.banner.diagonal_left.magenta": "Per anfractum sinisterae rubropurpureum",
  "block.minecraft.banner.diagonal_left.orange": "Per anfractus sinistrae aurantius",
  "block.minecraft.banner.diagonal_left.pink": "Per anfractus sinistrae roseus",
  "block.minecraft.banner.diagonal_left.purple": "Per anfractus sinistrae purpureus",
  "block.minecraft.banner.diagonal_left.red": "Per anfractus sinistrae ruber",
  "block.minecraft.banner.diagonal_left.white": "Per anfractus sinistrae albus",
  "block.minecraft.banner.diagonal_left.yellow": "Per anfractus sinistrae flavus",
  "block.minecraft.banner.diagonal_right.black": "Per anfractum nigrum",
  "block.minecraft.banner.diagonal_right.blue": "Per anfractum caeruleum",
  "block.minecraft.banner.diagonal_right.brown": "Per anfractum brunneum",
  "block.minecraft.banner.diagonal_right.cyan": "Per anfractum cyaneum",
  "block.minecraft.banner.diagonal_right.gray": "Per anfractum cinereum",
  "block.minecraft.banner.diagonal_right.green": "Per anfractum viride",
  "block.minecraft.banner.diagonal_right.light_blue": "Per anfractum aerium",
  "block.minecraft.banner.diagonal_right.light_gray": "Per anfractum canum",
  "block.minecraft.banner.diagonal_right.lime": "Per anfractum prasinum",
  "block.minecraft.banner.diagonal_right.magenta": "Per anfractum sinisterae",
  "block.minecraft.banner.diagonal_right.orange": "Per anfractum aurantium",
  "block.minecraft.banner.diagonal_right.pink": "Per anfractum roseum",
  "block.minecraft.banner.diagonal_right.purple": "Per anfractum purpureum",
  "block.minecraft.banner.diagonal_right.red": "Per anfractum rubrum",
  "block.minecraft.banner.diagonal_right.white": "Per anfractum album",
  "block.minecraft.banner.diagonal_right.yellow": "Per anfractum flavum",
  "block.minecraft.banner.diagonal_up_left.black": "Per anfractum conversum nigrum",
  "block.minecraft.banner.diagonal_up_left.blue": "Per anfractum conversum caeruleum",
  "block.minecraft.banner.diagonal_up_left.brown": "Per anfractum conversum brunneum",
  "block.minecraft.banner.diagonal_up_left.cyan": "Per anfractum conversum cyaneum",
  "block.minecraft.banner.diagonal_up_left.gray": "Per anfractum conversum cinereum",
  "block.minecraft.banner.diagonal_up_left.green": "Per anfractum conversum viridem",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Per anfractum conversum aerium",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Per anfractum conversum canum",
  "block.minecraft.banner.diagonal_up_left.lime": "Per anfractum conversum prasinum",
  "block.minecraft.banner.diagonal_up_left.magenta": "Per anfractum conversum rubropurpureum",
  "block.minecraft.banner.diagonal_up_left.orange": "Per anfractum conversum aurantium",
  "block.minecraft.banner.diagonal_up_left.pink": "Per anfractum conversum roseum",
  "block.minecraft.banner.diagonal_up_left.purple": "Per anfractum conversum purpureum",
  "block.minecraft.banner.diagonal_up_left.red": "Per anfractum conversum rubrum",
  "block.minecraft.banner.diagonal_up_left.white": "Per anfractum conversum album",
  "block.minecraft.banner.diagonal_up_left.yellow": "Per anfractum conversum flavum",
  "block.minecraft.banner.diagonal_up_right.black": "Per anfractum sinistrae conversum nigrum",
  "block.minecraft.banner.diagonal_up_right.blue": "Per anfractum sinistrae conversum caeruleum",
  "block.minecraft.banner.diagonal_up_right.brown": "Per anfractum sinistrae conversum brunneum",
  "block.minecraft.banner.diagonal_up_right.cyan": "Per anfractum sinistrae conversum cyaneum",
  "block.minecraft.banner.diagonal_up_right.gray": "Per anfractum sinistrae conversum cinereum",
  "block.minecraft.banner.diagonal_up_right.green": "Per anfractum sinistrae conversum viridem",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Per anfractum sinistrae conversum aerium",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Per anfractum sinistrae conversum canum",
  "block.minecraft.banner.diagonal_up_right.lime": "Per anfractum sinistrae conversum prasinum",
  "block.minecraft.banner.diagonal_up_right.magenta": "Per anfractum sinisterae conversum rubropurpureum",
  "block.minecraft.banner.diagonal_up_right.orange": "Per anfractum sinistrae conversum aurantium",
  "block.minecraft.banner.diagonal_up_right.pink": "Per anfractum sinistrae conversum roseum",
  "block.minecraft.banner.diagonal_up_right.purple": "Per anfractum sinistrae conversum purpureum",
  "block.minecraft.banner.diagonal_up_right.red": "Per anfractum sinistrae conversum rubrum",
  "block.minecraft.banner.diagonal_up_right.white": "Per anfractum sinistrae conversum album",
  "block.minecraft.banner.diagonal_up_right.yellow": "Per anfractum sinistrae conversum flavum",
  "block.minecraft.banner.flow.black": "Fluxus niger",
  "block.minecraft.banner.flow.blue": "Fluxus caeruleus",
  "block.minecraft.banner.flow.brown": "Fluxus brunneus",
  "block.minecraft.banner.flow.cyan": "Fluxus cyaneus",
  "block.minecraft.banner.flow.gray": "Fluxus cinereus",
  "block.minecraft.banner.flow.green": "Fluxus viridis",
  "block.minecraft.banner.flow.light_blue": "Fluxus aerius",
  "block.minecraft.banner.flow.light_gray": "Fluxus canus",
  "block.minecraft.banner.flow.lime": "Fluxus prasinus",
  "block.minecraft.banner.flow.magenta": "Fluxus rubropurpureus",
  "block.minecraft.banner.flow.orange": "Fluxus aurantius",
  "block.minecraft.banner.flow.pink": "Fluxus roseus",
  "block.minecraft.banner.flow.purple": "Fluxus purpureus",
  "block.minecraft.banner.flow.red": "Fluxus ruber",
  "block.minecraft.banner.flow.white": "Fluxus albus",
  "block.minecraft.banner.flow.yellow": "Fluxus flavus",
  "block.minecraft.banner.flower.black": "Imago floris nigrum",
  "block.minecraft.banner.flower.blue": "Imago floris caeruleum",
  "block.minecraft.banner.flower.brown": "Imago floris brunneum",
  "block.minecraft.banner.flower.cyan": "Imago floris cyaneum",
  "block.minecraft.banner.flower.gray": "Imago floris cinereum",
  "block.minecraft.banner.flower.green": "Imago floris viride",
  "block.minecraft.banner.flower.light_blue": "Imago floris aerium",
  "block.minecraft.banner.flower.light_gray": "Imago floris canum",
  "block.minecraft.banner.flower.lime": "Imago floris prasinum",
  "block.minecraft.banner.flower.magenta": "Imago floris rubropurpurei",
  "block.minecraft.banner.flower.orange": "Imago floris aurantium",
  "block.minecraft.banner.flower.pink": "Imago floris roseum",
  "block.minecraft.banner.flower.purple": "Imago floris purpureum",
  "block.minecraft.banner.flower.red": "Imago floris rubrum",
  "block.minecraft.banner.flower.white": "Imago floris album",
  "block.minecraft.banner.flower.yellow": "Imago floris flavum",
  "block.minecraft.banner.globe.black": "Globus niger",
  "block.minecraft.banner.globe.blue": "Globus caeruleus",
  "block.minecraft.banner.globe.brown": "Globus brunneus",
  "block.minecraft.banner.globe.cyan": "Globus cyaneus",
  "block.minecraft.banner.globe.gray": "Globus cinereus",
  "block.minecraft.banner.globe.green": "Globus viridis",
  "block.minecraft.banner.globe.light_blue": "Globus aerius",
  "block.minecraft.banner.globe.light_gray": "Globus canus",
  "block.minecraft.banner.globe.lime": "Globus prasinus",
  "block.minecraft.banner.globe.magenta": "Globus rubropurpureus",
  "block.minecraft.banner.globe.orange": "Globus aurantius",
  "block.minecraft.banner.globe.pink": "Globus roseus",
  "block.minecraft.banner.globe.purple": "Globus purpureus",
  "block.minecraft.banner.globe.red": "Globus ruber",
  "block.minecraft.banner.globe.white": "Globus albus",
  "block.minecraft.banner.globe.yellow": "Globus flavus",
  "block.minecraft.banner.gradient.black": "Clivus niger",
  "block.minecraft.banner.gradient.blue": "Clivus caeruleus",
  "block.minecraft.banner.gradient.brown": "Clivus brunneus",
  "block.minecraft.banner.gradient.cyan": "Clivus cyaneus",
  "block.minecraft.banner.gradient.gray": "Clivus cinereus",
  "block.minecraft.banner.gradient.green": "Clivus viridis",
  "block.minecraft.banner.gradient.light_blue": "Clivus aerius",
  "block.minecraft.banner.gradient.light_gray": "Clivus canus",
  "block.minecraft.banner.gradient.lime": "Clivus prasinus",
  "block.minecraft.banner.gradient.magenta": "Clivus rubropurpureus",
  "block.minecraft.banner.gradient.orange": "Clivus aurantius",
  "block.minecraft.banner.gradient.pink": "Clivus roseus",
  "block.minecraft.banner.gradient.purple": "Clivus purpureus",
  "block.minecraft.banner.gradient.red": "Clivus ruber",
  "block.minecraft.banner.gradient.white": "Clivus albus",
  "block.minecraft.banner.gradient.yellow": "Clivus flavus",
  "block.minecraft.banner.gradient_up.black": "Clivus basis niger",
  "block.minecraft.banner.gradient_up.blue": "Clivus basis caeruleus",
  "block.minecraft.banner.gradient_up.brown": "Clivus basis brunneus",
  "block.minecraft.banner.gradient_up.cyan": "Clivus basis cyaneus",
  "block.minecraft.banner.gradient_up.gray": "Clivus basis cinereus",
  "block.minecraft.banner.gradient_up.green": "Clivus basis viridis",
  "block.minecraft.banner.gradient_up.light_blue": "Clivus basis aerius",
  "block.minecraft.banner.gradient_up.light_gray": "Clivus basis canus",
  "block.minecraft.banner.gradient_up.lime": "Clivus basis prasinus",
  "block.minecraft.banner.gradient_up.magenta": "Clivus basis rubropurpureus",
  "block.minecraft.banner.gradient_up.orange": "Clivus basis aurantius",
  "block.minecraft.banner.gradient_up.pink": "Clivus basis roseus",
  "block.minecraft.banner.gradient_up.purple": "Clivus basis purpureus",
  "block.minecraft.banner.gradient_up.red": "Clivus basis ruber",
  "block.minecraft.banner.gradient_up.white": "Clivus basis albus",
  "block.minecraft.banner.gradient_up.yellow": "Clivus basis flavus",
  "block.minecraft.banner.guster.black": "Flator niger",
  "block.minecraft.banner.guster.blue": "Flator caeruleus",
  "block.minecraft.banner.guster.brown": "Flator brunneus",
  "block.minecraft.banner.guster.cyan": "Flator cyaneus",
  "block.minecraft.banner.guster.gray": "Flator cinereus",
  "block.minecraft.banner.guster.green": "Flator viridis",
  "block.minecraft.banner.guster.light_blue": "Flator aerius",
  "block.minecraft.banner.guster.light_gray": "Flator canus",
  "block.minecraft.banner.guster.lime": "Flator prasinus",
  "block.minecraft.banner.guster.magenta": "Flator rubropurpureus",
  "block.minecraft.banner.guster.orange": "Flator aurantius",
  "block.minecraft.banner.guster.pink": "Flator roseus",
  "block.minecraft.banner.guster.purple": "Flator purpureus",
  "block.minecraft.banner.guster.red": "Flator ruber",
  "block.minecraft.banner.guster.white": "Flator albus",
  "block.minecraft.banner.guster.yellow": "Flator flavitus",
  "block.minecraft.banner.half_horizontal.black": "Per fasciam nigram",
  "block.minecraft.banner.half_horizontal.blue": "Per fasciam caeruleam",
  "block.minecraft.banner.half_horizontal.brown": "Per fasciam brunneam",
  "block.minecraft.banner.half_horizontal.cyan": "Per fasciam cyaneam",
  "block.minecraft.banner.half_horizontal.gray": "Per fasciam cineream",
  "block.minecraft.banner.half_horizontal.green": "Per fasciam viridem",
  "block.minecraft.banner.half_horizontal.light_blue": "Per fasciam aeriam",
  "block.minecraft.banner.half_horizontal.light_gray": "Per fasciam canam",
  "block.minecraft.banner.half_horizontal.lime": "Per fasciam prasinam",
  "block.minecraft.banner.half_horizontal.magenta": "Per fasciam rubropurpuream",
  "block.minecraft.banner.half_horizontal.orange": "Per fasciam aurantiam",
  "block.minecraft.banner.half_horizontal.pink": "Per fasciam roseam",
  "block.minecraft.banner.half_horizontal.purple": "Per fasciam purpuream",
  "block.minecraft.banner.half_horizontal.red": "Per fasciam rubram",
  "block.minecraft.banner.half_horizontal.white": "Per fasciam albam",
  "block.minecraft.banner.half_horizontal.yellow": "Per fasciam flavam",
  "block.minecraft.banner.half_horizontal_bottom.black": "Per fasciam conversam nigram",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Per fasciam conversam caeruleam",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Per fasciam conversam brunneam",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Per fasciam conversam cyaneam",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Per fasciam conversam cineream",
  "block.minecraft.banner.half_horizontal_bottom.green": "Per fasciam conversam viridem",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Per fasciam conversam aeriam",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Per fasciam conversam canam",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Per fasciam conversam prasinam",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Per fasciam conversam rubropurpuream",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Per fasciam conversam aurantiam",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Per fasciam conversam roseam",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Per fasciam conversam purpuream",
  "block.minecraft.banner.half_horizontal_bottom.red": "Per fasciam conversam rubram",
  "block.minecraft.banner.half_horizontal_bottom.white": "Per fasciam conversam albam",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Per fasciam conversam flavam",
  "block.minecraft.banner.half_vertical.black": "Per palum nigrum",
  "block.minecraft.banner.half_vertical.blue": "Per palum caeruleum",
  "block.minecraft.banner.half_vertical.brown": "Per palum brunneum",
  "block.minecraft.banner.half_vertical.cyan": "Per palum cyaneum",
  "block.minecraft.banner.half_vertical.gray": "Per palum cinereum",
  "block.minecraft.banner.half_vertical.green": "Per palum viridem",
  "block.minecraft.banner.half_vertical.light_blue": "Per palum aerium",
  "block.minecraft.banner.half_vertical.light_gray": "Per palum canum",
  "block.minecraft.banner.half_vertical.lime": "Per palum prasinum",
  "block.minecraft.banner.half_vertical.magenta": "Per palum rubropurpureum",
  "block.minecraft.banner.half_vertical.orange": "Per palum aurantium",
  "block.minecraft.banner.half_vertical.pink": "Per palum roseum",
  "block.minecraft.banner.half_vertical.purple": "Per palum purpureum",
  "block.minecraft.banner.half_vertical.red": "Per palum rubrum",
  "block.minecraft.banner.half_vertical.white": "Per palum album",
  "block.minecraft.banner.half_vertical.yellow": "Per palum flavum",
  "block.minecraft.banner.half_vertical_right.black": "Per Palum Conversum Nigrum",
  "block.minecraft.banner.half_vertical_right.blue": "Per palum conversum caerulem",
  "block.minecraft.banner.half_vertical_right.brown": "Per palum conversum brunneum",
  "block.minecraft.banner.half_vertical_right.cyan": "Per palum conversum cyaneum",
  "block.minecraft.banner.half_vertical_right.gray": "Per palum conversum cinereum",
  "block.minecraft.banner.half_vertical_right.green": "Per palum conversum viridem",
  "block.minecraft.banner.half_vertical_right.light_blue": "Per palum conversum aerium",
  "block.minecraft.banner.half_vertical_right.light_gray": "Per palum conversum canum",
  "block.minecraft.banner.half_vertical_right.lime": "Per palum conversum prasinum",
  "block.minecraft.banner.half_vertical_right.magenta": "Per palum conversum rubropurpureum",
  "block.minecraft.banner.half_vertical_right.orange": "Per palum conversum aurantium",
  "block.minecraft.banner.half_vertical_right.pink": "Per palum conversum roseum",
  "block.minecraft.banner.half_vertical_right.purple": "Per palum conversum purpureum",
  "block.minecraft.banner.half_vertical_right.red": "Per palum conversum rubrum",
  "block.minecraft.banner.half_vertical_right.white": "Per palum conversum album",
  "block.minecraft.banner.half_vertical_right.yellow": "Per palum conversum flavum",
  "block.minecraft.banner.mojang.black": "Res nigra",
  "block.minecraft.banner.mojang.blue": "Res caerulea",
  "block.minecraft.banner.mojang.brown": "Res brunnea",
  "block.minecraft.banner.mojang.cyan": "Res cyanea",
  "block.minecraft.banner.mojang.gray": "Res cinerea",
  "block.minecraft.banner.mojang.green": "Res viridis",
  "block.minecraft.banner.mojang.light_blue": "Res aeria",
  "block.minecraft.banner.mojang.light_gray": "Res cana",
  "block.minecraft.banner.mojang.lime": "Res prasina",
  "block.minecraft.banner.mojang.magenta": "Res rubropurpurea",
  "block.minecraft.banner.mojang.orange": "Res aurantia",
  "block.minecraft.banner.mojang.pink": "Res rosea",
  "block.minecraft.banner.mojang.purple": "Res purpurea",
  "block.minecraft.banner.mojang.red": "Res rubra",
  "block.minecraft.banner.mojang.white": "Res alba",
  "block.minecraft.banner.mojang.yellow": "Res flava",
  "block.minecraft.banner.piglin.black": "Rostrum nigrum",
  "block.minecraft.banner.piglin.blue": "Rostrum caeruleum",
  "block.minecraft.banner.piglin.brown": "Rostrum brunneum",
  "block.minecraft.banner.piglin.cyan": "Rostrum cyaneum",
  "block.minecraft.banner.piglin.gray": "Rostrum cinereum",
  "block.minecraft.banner.piglin.green": "Rostrum viride",
  "block.minecraft.banner.piglin.light_blue": "Rostrum aerium",
  "block.minecraft.banner.piglin.light_gray": "Rostrum canum",
  "block.minecraft.banner.piglin.lime": "Rostrum prasinum",
  "block.minecraft.banner.piglin.magenta": "Rostrum rubropurpureum",
  "block.minecraft.banner.piglin.orange": "Rostrum aurantium",
  "block.minecraft.banner.piglin.pink": "Rostrum roseum",
  "block.minecraft.banner.piglin.purple": "Rostrum purpureum",
  "block.minecraft.banner.piglin.red": "Rostrum rubrum",
  "block.minecraft.banner.piglin.white": "Rostrum album",
  "block.minecraft.banner.piglin.yellow": "Rostrum flavum",
  "block.minecraft.banner.rhombus.black": "Rhombus niger",
  "block.minecraft.banner.rhombus.blue": "Rhombus caeruleus",
  "block.minecraft.banner.rhombus.brown": "Rhombus brunneus",
  "block.minecraft.banner.rhombus.cyan": "Rhombus cyaneus",
  "block.minecraft.banner.rhombus.gray": "Rhombus cinereus",
  "block.minecraft.banner.rhombus.green": "Rhombus viridis",
  "block.minecraft.banner.rhombus.light_blue": "Rhombus aerius",
  "block.minecraft.banner.rhombus.light_gray": "Rhombus canus",
  "block.minecraft.banner.rhombus.lime": "Rhombus prasinus",
  "block.minecraft.banner.rhombus.magenta": "Rhombus rubropurpureus",
  "block.minecraft.banner.rhombus.orange": "Rhombus aurantius",
  "block.minecraft.banner.rhombus.pink": "Rhombus roseus",
  "block.minecraft.banner.rhombus.purple": "Rhombus purpureus",
  "block.minecraft.banner.rhombus.red": "Rhombus ruber",
  "block.minecraft.banner.rhombus.white": "Rhombus albus",
  "block.minecraft.banner.rhombus.yellow": "Rhombus flavus",
  "block.minecraft.banner.skull.black": "Imago calvae nigra",
  "block.minecraft.banner.skull.blue": "Imago calvae caerulea",
  "block.minecraft.banner.skull.brown": "Imago calvae brunnea",
  "block.minecraft.banner.skull.cyan": "Imago calvae cyanea",
  "block.minecraft.banner.skull.gray": "Imago calvae cinerea",
  "block.minecraft.banner.skull.green": "Imago calvae viridis",
  "block.minecraft.banner.skull.light_blue": "Imago calvae aeria",
  "block.minecraft.banner.skull.light_gray": "Imago calvae cana",
  "block.minecraft.banner.skull.lime": "Imago calvae prasina",
  "block.minecraft.banner.skull.magenta": "Imago calvae rubropurpurea",
  "block.minecraft.banner.skull.orange": "Imago calvae aurantia",
  "block.minecraft.banner.skull.pink": "Imago calvae rosea",
  "block.minecraft.banner.skull.purple": "Imago calvae purpurea",
  "block.minecraft.banner.skull.red": "Imago calvae rubra",
  "block.minecraft.banner.skull.white": "Imago calvae alba",
  "block.minecraft.banner.skull.yellow": "Imago calvae flava",
  "block.minecraft.banner.small_stripes.black": "Pali niger",
  "block.minecraft.banner.small_stripes.blue": "Pali caeruleus",
  "block.minecraft.banner.small_stripes.brown": "Pali brunneus",
  "block.minecraft.banner.small_stripes.cyan": "Pali cyaneus",
  "block.minecraft.banner.small_stripes.gray": "Pali cinereus",
  "block.minecraft.banner.small_stripes.green": "Pali viridisa",
  "block.minecraft.banner.small_stripes.light_blue": "Pali aerius",
  "block.minecraft.banner.small_stripes.light_gray": "Pali canus",
  "block.minecraft.banner.small_stripes.lime": "Pali prasinus",
  "block.minecraft.banner.small_stripes.magenta": "Pali rubropurpurei",
  "block.minecraft.banner.small_stripes.orange": "Pali aurantius",
  "block.minecraft.banner.small_stripes.pink": "Pali roseus",
  "block.minecraft.banner.small_stripes.purple": "Pali purpureus",
  "block.minecraft.banner.small_stripes.red": "Pali ruber",
  "block.minecraft.banner.small_stripes.white": "Pali albus",
  "block.minecraft.banner.small_stripes.yellow": "Pali flavus",
  "block.minecraft.banner.square_bottom_left.black": "Bas dexterae cantonis nigra",
  "block.minecraft.banner.square_bottom_left.blue": "Bas dexterae cantonis caerulea",
  "block.minecraft.banner.square_bottom_left.brown": "Bas dexterae cantonis brunnea",
  "block.minecraft.banner.square_bottom_left.cyan": "Bas dexterae cantonis cyanea",
  "block.minecraft.banner.square_bottom_left.gray": "Bas dexterae cantonis cinerea",
  "block.minecraft.banner.square_bottom_left.green": "Bas dexterae cantonis viridis",
  "block.minecraft.banner.square_bottom_left.light_blue": "Bas dexterae cantonis aeria",
  "block.minecraft.banner.square_bottom_left.light_gray": "Bas dexterae cantonis cana",
  "block.minecraft.banner.square_bottom_left.lime": "Bas dexterae cantonis prasina",
  "block.minecraft.banner.square_bottom_left.magenta": "Bas dexterae cantonis rubropurpurea",
  "block.minecraft.banner.square_bottom_left.orange": "Bas dexterae cantonis aurantia",
  "block.minecraft.banner.square_bottom_left.pink": "Bas dexterae cantonis rosea",
  "block.minecraft.banner.square_bottom_left.purple": "Bas dexterae cantonis purpurea",
  "block.minecraft.banner.square_bottom_left.red": "Bas dexterae cantonis rubra",
  "block.minecraft.banner.square_bottom_left.white": "Bas dexterae cantonis alba",
  "block.minecraft.banner.square_bottom_left.yellow": "Bas dexterae cantonis flava",
  "block.minecraft.banner.square_bottom_right.black": "Angulo deorsum sinistro nigro distinctum",
  "block.minecraft.banner.square_bottom_right.blue": "Angulo deorsum sinistro caeruleo distinctum",
  "block.minecraft.banner.square_bottom_right.brown": "Angulo deorsum sinistro brunneo distinctum",
  "block.minecraft.banner.square_bottom_right.cyan": "Angulo deorsum sinistro cyaneo distinctum",
  "block.minecraft.banner.square_bottom_right.gray": "Angulo deorsum sinistro cinereo distinctum",
  "block.minecraft.banner.square_bottom_right.green": "Angulo deorsum sinistro viridi distinctum",
  "block.minecraft.banner.square_bottom_right.light_blue": "Angulo deorsum sinistro aerio distinctum",
  "block.minecraft.banner.square_bottom_right.light_gray": "Angulo deorsum sinistro cano distinctum",
  "block.minecraft.banner.square_bottom_right.lime": "Angulo deorsum sinistro prasino distinctum",
  "block.minecraft.banner.square_bottom_right.magenta": "Angulo deorsum sinistro rubropurpureo distinctum",
  "block.minecraft.banner.square_bottom_right.orange": "Angulo deorsum sinistro aurantio distinctum",
  "block.minecraft.banner.square_bottom_right.pink": "Angulo deorsum sinistro roseo distinctum",
  "block.minecraft.banner.square_bottom_right.purple": "Angulo deorsum sinistro purpureo distinctum",
  "block.minecraft.banner.square_bottom_right.red": "Angulo deorsum sinistro rubro distinctum",
  "block.minecraft.banner.square_bottom_right.white": "Angulo deorsum sinistro albo distinctum",
  "block.minecraft.banner.square_bottom_right.yellow": "Angulo deorsum sinistro flavo distinctum",
  "block.minecraft.banner.square_top_left.black": "Caput dextrae cantonis nigri",
  "block.minecraft.banner.square_top_left.blue": "Caput dextrae cantonis caerulei",
  "block.minecraft.banner.square_top_left.brown": "Caput dextrae cantonis brunnei",
  "block.minecraft.banner.square_top_left.cyan": "Caput dextrae cantonis cyanei",
  "block.minecraft.banner.square_top_left.gray": "Caput dextrae cantonis cinerei",
  "block.minecraft.banner.square_top_left.green": "Caput dextrae cantonis viridis",
  "block.minecraft.banner.square_top_left.light_blue": "Caput dextrae cantonis aerii",
  "block.minecraft.banner.square_top_left.light_gray": "Caput dextrae cantonis cani",
  "block.minecraft.banner.square_top_left.lime": "Caput dextrae cantonis prasini",
  "block.minecraft.banner.square_top_left.magenta": "Caput dextrae cantonis rubropurpurei",
  "block.minecraft.banner.square_top_left.orange": "Caput dextrae cantonis aurantii",
  "block.minecraft.banner.square_top_left.pink": "Caput dextrae cantonis rosei",
  "block.minecraft.banner.square_top_left.purple": "Caput dextrae cantonis purpurei",
  "block.minecraft.banner.square_top_left.red": "Caput dextrae cantonis rubri",
  "block.minecraft.banner.square_top_left.white": "Caput dextrae cantonis albi",
  "block.minecraft.banner.square_top_left.yellow": "Caput dextrae cantonis flavi",
  "block.minecraft.banner.square_top_right.black": "Caput sinistrae cantonis nigri",
  "block.minecraft.banner.square_top_right.blue": "Caput sinistrae cantonis caerulei",
  "block.minecraft.banner.square_top_right.brown": "Caput sinistrae cantonis brunnei",
  "block.minecraft.banner.square_top_right.cyan": "Caput sinistrae cantonis cyanei",
  "block.minecraft.banner.square_top_right.gray": "Caput sinistrae cantonis cinerei",
  "block.minecraft.banner.square_top_right.green": "Caput sinistrae cantonis viridis",
  "block.minecraft.banner.square_top_right.light_blue": "Caput sinistrae cantonis aerii",
  "block.minecraft.banner.square_top_right.light_gray": "Caput sinistrae cantonis cani",
  "block.minecraft.banner.square_top_right.lime": "Caput sinistrae cantonis prasini",
  "block.minecraft.banner.square_top_right.magenta": "Caput sinistrae cantonis rubropurpurei",
  "block.minecraft.banner.square_top_right.orange": "Caput sinistrae cantonis aurantii",
  "block.minecraft.banner.square_top_right.pink": "Caput sinistrae cantonis rosei",
  "block.minecraft.banner.square_top_right.purple": "Caput sinistrae cantonis purpurei",
  "block.minecraft.banner.square_top_right.red": "Caput sinistrae cantonis rubri",
  "block.minecraft.banner.square_top_right.white": "Caput sinistrae cantonis albi",
  "block.minecraft.banner.square_top_right.yellow": "Caput sinistrae cantonis flavi",
  "block.minecraft.banner.straight_cross.black": "Crux nigra",
  "block.minecraft.banner.straight_cross.blue": "Crux caerulea",
  "block.minecraft.banner.straight_cross.brown": "Crux brunnea",
  "block.minecraft.banner.straight_cross.cyan": "Crux cyanea",
  "block.minecraft.banner.straight_cross.gray": "Crux cinerea",
  "block.minecraft.banner.straight_cross.green": "Crux viridis",
  "block.minecraft.banner.straight_cross.light_blue": "Crux aeria",
  "block.minecraft.banner.straight_cross.light_gray": "Crux cana",
  "block.minecraft.banner.straight_cross.lime": "Crux prasina",
  "block.minecraft.banner.straight_cross.magenta": "Crux rubropurpurea",
  "block.minecraft.banner.straight_cross.orange": "Crux aurantia",
  "block.minecraft.banner.straight_cross.pink": "Crux rosea",
  "block.minecraft.banner.straight_cross.purple": "Crux purpurea",
  "block.minecraft.banner.straight_cross.red": "Crux rubra",
  "block.minecraft.banner.straight_cross.white": "Crux alba",
  "block.minecraft.banner.straight_cross.yellow": "Crux flava",
  "block.minecraft.banner.stripe_bottom.black": "Bas nigra",
  "block.minecraft.banner.stripe_bottom.blue": "Bas caerulea",
  "block.minecraft.banner.stripe_bottom.brown": "Bas brunnea",
  "block.minecraft.banner.stripe_bottom.cyan": "Bas cyanea",
  "block.minecraft.banner.stripe_bottom.gray": "Bas cinerea",
  "block.minecraft.banner.stripe_bottom.green": "Bas viridis",
  "block.minecraft.banner.stripe_bottom.light_blue": "Bas aeria",
  "block.minecraft.banner.stripe_bottom.light_gray": "Bas cana",
  "block.minecraft.banner.stripe_bottom.lime": "Bas prasina",
  "block.minecraft.banner.stripe_bottom.magenta": "Bas rubropurpurea",
  "block.minecraft.banner.stripe_bottom.orange": "Bas aurantia",
  "block.minecraft.banner.stripe_bottom.pink": "Bas rosea",
  "block.minecraft.banner.stripe_bottom.purple": "Bas purpurea",
  "block.minecraft.banner.stripe_bottom.red": "Bas rubra",
  "block.minecraft.banner.stripe_bottom.white": "Bas alba",
  "block.minecraft.banner.stripe_bottom.yellow": "Bas flava",
  "block.minecraft.banner.stripe_center.black": "Palus niger",
  "block.minecraft.banner.stripe_center.blue": "Palus caeruleus",
  "block.minecraft.banner.stripe_center.brown": "Palus brunneus",
  "block.minecraft.banner.stripe_center.cyan": "Palus cyaneus",
  "block.minecraft.banner.stripe_center.gray": "Palus cinereus",
  "block.minecraft.banner.stripe_center.green": "Palus viridis",
  "block.minecraft.banner.stripe_center.light_blue": "Palus aerius",
  "block.minecraft.banner.stripe_center.light_gray": "Palus canus",
  "block.minecraft.banner.stripe_center.lime": "Palus prasinus",
  "block.minecraft.banner.stripe_center.magenta": "Palus rubropurpureus",
  "block.minecraft.banner.stripe_center.orange": "Palus aurantius",
  "block.minecraft.banner.stripe_center.pink": "Palus roseus",
  "block.minecraft.banner.stripe_center.purple": "Palus purpureus",
  "block.minecraft.banner.stripe_center.red": "Palus ruber",
  "block.minecraft.banner.stripe_center.white": "Palus albus",
  "block.minecraft.banner.stripe_center.yellow": "Palus flavus",
  "block.minecraft.banner.stripe_downleft.black": "Anfractus sinistrae niger",
  "block.minecraft.banner.stripe_downleft.blue": "Anfractus sinistrae caeruleus",
  "block.minecraft.banner.stripe_downleft.brown": "Anfractus sinistrae brunneus",
  "block.minecraft.banner.stripe_downleft.cyan": "Anfractus sinistrae cyaneus",
  "block.minecraft.banner.stripe_downleft.gray": "Anfractus sinistrae cinereus",
  "block.minecraft.banner.stripe_downleft.green": "Anfractus sinistrae viridis",
  "block.minecraft.banner.stripe_downleft.light_blue": "Anfractus sinistrae aerius",
  "block.minecraft.banner.stripe_downleft.light_gray": "Anfractus sinistrae canus",
  "block.minecraft.banner.stripe_downleft.lime": "Anfractus sinistrae prasinus",
  "block.minecraft.banner.stripe_downleft.magenta": "Anfractus sinisterae rubropurpureus",
  "block.minecraft.banner.stripe_downleft.orange": "Anfractus sinistrae aurantius",
  "block.minecraft.banner.stripe_downleft.pink": "Anfractus sinistrae roseus",
  "block.minecraft.banner.stripe_downleft.purple": "Anfractus sinistrae purpureus",
  "block.minecraft.banner.stripe_downleft.red": "Anfractus sinistrae ruber",
  "block.minecraft.banner.stripe_downleft.white": "Anfractus sinistrae albus",
  "block.minecraft.banner.stripe_downleft.yellow": "Anfractus sinistrae flavus",
  "block.minecraft.banner.stripe_downright.black": "Anfractus niger",
  "block.minecraft.banner.stripe_downright.blue": "Anfractus caeruleus",
  "block.minecraft.banner.stripe_downright.brown": "Anfractus brunneus",
  "block.minecraft.banner.stripe_downright.cyan": "Anfractus cyaneus",
  "block.minecraft.banner.stripe_downright.gray": "Anfractus cinereus",
  "block.minecraft.banner.stripe_downright.green": "Anfractus viridis",
  "block.minecraft.banner.stripe_downright.light_blue": "Anfractus aerius",
  "block.minecraft.banner.stripe_downright.light_gray": "Anfractus canus",
  "block.minecraft.banner.stripe_downright.lime": "Anfractus prasinus",
  "block.minecraft.banner.stripe_downright.magenta": "Anfractus rubropurpureus",
  "block.minecraft.banner.stripe_downright.orange": "Anfractus aurantius",
  "block.minecraft.banner.stripe_downright.pink": "Anfractus roseus",
  "block.minecraft.banner.stripe_downright.purple": "Anfractus purpureus",
  "block.minecraft.banner.stripe_downright.red": "Anfractus ruber",
  "block.minecraft.banner.stripe_downright.white": "Anfractus albus",
  "block.minecraft.banner.stripe_downright.yellow": "Anfractus flavus",
  "block.minecraft.banner.stripe_left.black": "Palus dextrae niger",
  "block.minecraft.banner.stripe_left.blue": "Palus dextrae caeruleus",
  "block.minecraft.banner.stripe_left.brown": "Palus dextrae brunneus",
  "block.minecraft.banner.stripe_left.cyan": "Palus dextrae cyaneus",
  "block.minecraft.banner.stripe_left.gray": "Palus dextrae cinereus",
  "block.minecraft.banner.stripe_left.green": "Palus dextrae viridis",
  "block.minecraft.banner.stripe_left.light_blue": "Palus dextrae aerius",
  "block.minecraft.banner.stripe_left.light_gray": "Palus dextrae canus",
  "block.minecraft.banner.stripe_left.lime": "Palus dextrae prasinus",
  "block.minecraft.banner.stripe_left.magenta": "Palus dexterae rubropurpureus",
  "block.minecraft.banner.stripe_left.orange": "Palus dextrae aurantius",
  "block.minecraft.banner.stripe_left.pink": "Palus dextrae roseus",
  "block.minecraft.banner.stripe_left.purple": "Palus dextrae purpureus",
  "block.minecraft.banner.stripe_left.red": "Palus dextrae ruber",
  "block.minecraft.banner.stripe_left.white": "Palus dextrae albus",
  "block.minecraft.banner.stripe_left.yellow": "Palus dextrae flavus",
  "block.minecraft.banner.stripe_middle.black": "Fascia nigra distinctum",
  "block.minecraft.banner.stripe_middle.blue": "Fascia caerulea distinctum",
  "block.minecraft.banner.stripe_middle.brown": "Fascia brunnea distinctum",
  "block.minecraft.banner.stripe_middle.cyan": "Fascia cyanea distinctum",
  "block.minecraft.banner.stripe_middle.gray": "Fascia cinerea distinctum",
  "block.minecraft.banner.stripe_middle.green": "Fascia viridi distinctum",
  "block.minecraft.banner.stripe_middle.light_blue": "Fascia aeria distinctum",
  "block.minecraft.banner.stripe_middle.light_gray": "Fascia cana distinctum",
  "block.minecraft.banner.stripe_middle.lime": "Fascia prasina distinctum",
  "block.minecraft.banner.stripe_middle.magenta": "Fascia rubropurpurea distinctum",
  "block.minecraft.banner.stripe_middle.orange": "Fascia aurantia distinctum",
  "block.minecraft.banner.stripe_middle.pink": "Fascia rosea distinctum",
  "block.minecraft.banner.stripe_middle.purple": "Fascia purpurea distinctum",
  "block.minecraft.banner.stripe_middle.red": "Fascia rubra distinctum",
  "block.minecraft.banner.stripe_middle.white": "Fascia candida distinctum",
  "block.minecraft.banner.stripe_middle.yellow": "Fascia flava distinctum",
  "block.minecraft.banner.stripe_right.black": "Palus sinistrae niger",
  "block.minecraft.banner.stripe_right.blue": "Palus sinistrae caeruleus",
  "block.minecraft.banner.stripe_right.brown": "Palus sinistrae brunneus",
  "block.minecraft.banner.stripe_right.cyan": "Palus sinistrae cyaneus",
  "block.minecraft.banner.stripe_right.gray": "Palus sinistrae cinereus",
  "block.minecraft.banner.stripe_right.green": "Palus sinistrae viridis",
  "block.minecraft.banner.stripe_right.light_blue": "Palus sinistrae aerius",
  "block.minecraft.banner.stripe_right.light_gray": "Palus sinistrae canus",
  "block.minecraft.banner.stripe_right.lime": "Palus sinistrae prasinus",
  "block.minecraft.banner.stripe_right.magenta": "Palus sinisterae rubropurpureus",
  "block.minecraft.banner.stripe_right.orange": "Palus sinistrae aurantius",
  "block.minecraft.banner.stripe_right.pink": "Palus sinistrae roseus",
  "block.minecraft.banner.stripe_right.purple": "Palus sinistrae purpureus",
  "block.minecraft.banner.stripe_right.red": "Palus sinistrae ruber",
  "block.minecraft.banner.stripe_right.white": "Palus sinistrae albus",
  "block.minecraft.banner.stripe_right.yellow": "Palus sinistrae flavus",
  "block.minecraft.banner.stripe_top.black": "Caput nigra",
  "block.minecraft.banner.stripe_top.blue": "Caput caeruleum",
  "block.minecraft.banner.stripe_top.brown": "Caput brunneum",
  "block.minecraft.banner.stripe_top.cyan": "Caput cyaneum",
  "block.minecraft.banner.stripe_top.gray": "Caput cinereum",
  "block.minecraft.banner.stripe_top.green": "Caput viride",
  "block.minecraft.banner.stripe_top.light_blue": "Caput aerium",
  "block.minecraft.banner.stripe_top.light_gray": "Caput canum",
  "block.minecraft.banner.stripe_top.lime": "Caput prasinum",
  "block.minecraft.banner.stripe_top.magenta": "Caput rubropurpureum",
  "block.minecraft.banner.stripe_top.orange": "Caput aurantium",
  "block.minecraft.banner.stripe_top.pink": "Caput roseum",
  "block.minecraft.banner.stripe_top.purple": "Caput purpureum",
  "block.minecraft.banner.stripe_top.red": "Caput Rubra",
  "block.minecraft.banner.stripe_top.white": "Caput album",
  "block.minecraft.banner.stripe_top.yellow": "Caput flavum",
  "block.minecraft.banner.triangle_bottom.black": "Triangulum nigrum",
  "block.minecraft.banner.triangle_bottom.blue": "Triangulum caeruleum",
  "block.minecraft.banner.triangle_bottom.brown": "Triangulum brunneum",
  "block.minecraft.banner.triangle_bottom.cyan": "Triangulum cyaneum",
  "block.minecraft.banner.triangle_bottom.gray": "Triangulum cinereum",
  "block.minecraft.banner.triangle_bottom.green": "Triangulum viride",
  "block.minecraft.banner.triangle_bottom.light_blue": "Triangulum aerium",
  "block.minecraft.banner.triangle_bottom.light_gray": "Triangulum canum",
  "block.minecraft.banner.triangle_bottom.lime": "Triangulum prasinum",
  "block.minecraft.banner.triangle_bottom.magenta": "Triangulum rubropurpureum",
  "block.minecraft.banner.triangle_bottom.orange": "Triangulum aurantium",
  "block.minecraft.banner.triangle_bottom.pink": "Triangulum roseum",
  "block.minecraft.banner.triangle_bottom.purple": "Triangulum purpureum",
  "block.minecraft.banner.triangle_bottom.red": "Triangulum rubrum",
  "block.minecraft.banner.triangle_bottom.white": "Triangulum album",
  "block.minecraft.banner.triangle_bottom.yellow": "Triangulum flavum",
  "block.minecraft.banner.triangle_top.black": "Triangulum conversum nigrum",
  "block.minecraft.banner.triangle_top.blue": "Triangulum conversum caeruleum",
  "block.minecraft.banner.triangle_top.brown": "Triangulum conversum brunneum",
  "block.minecraft.banner.triangle_top.cyan": "Triangulum conversum cyaneum",
  "block.minecraft.banner.triangle_top.gray": "Triangulum conversum cinereum",
  "block.minecraft.banner.triangle_top.green": "Triangulum conversum viride",
  "block.minecraft.banner.triangle_top.light_blue": "Triangulum conversum aerium",
  "block.minecraft.banner.triangle_top.light_gray": "Triangulum conversum canum",
  "block.minecraft.banner.triangle_top.lime": "Triangulum conversum prasinum",
  "block.minecraft.banner.triangle_top.magenta": "Triangulum conversum rubropurpureum",
  "block.minecraft.banner.triangle_top.orange": "Triangulum conversum aurantium",
  "block.minecraft.banner.triangle_top.pink": "Triangulum conversum roseum",
  "block.minecraft.banner.triangle_top.purple": "Triangulum conversum purpureum",
  "block.minecraft.banner.triangle_top.red": "Triangulum conversum rubrum",
  "block.minecraft.banner.triangle_top.white": "Triangulum Conversum Album",
  "block.minecraft.banner.triangle_top.yellow": "Triangulum conversum flavum",
  "block.minecraft.banner.triangles_bottom.black": "Bas curva nigra",
  "block.minecraft.banner.triangles_bottom.blue": "Bas curva caerulea",
  "block.minecraft.banner.triangles_bottom.brown": "Bas curva brunnea",
  "block.minecraft.banner.triangles_bottom.cyan": "Bas curva cyanea",
  "block.minecraft.banner.triangles_bottom.gray": "Bas curva cinerea",
  "block.minecraft.banner.triangles_bottom.green": "Bas curva viridis",
  "block.minecraft.banner.triangles_bottom.light_blue": "Bas curva aeria",
  "block.minecraft.banner.triangles_bottom.light_gray": "Bas curva cana",
  "block.minecraft.banner.triangles_bottom.lime": "Bas curva prasina",
  "block.minecraft.banner.triangles_bottom.magenta": "Bas curva rubropurpurea",
  "block.minecraft.banner.triangles_bottom.orange": "Bas curva aurantia",
  "block.minecraft.banner.triangles_bottom.pink": "Bas curva rosea",
  "block.minecraft.banner.triangles_bottom.purple": "Bas curva purpurea",
  "block.minecraft.banner.triangles_bottom.red": "Bas curva rubra",
  "block.minecraft.banner.triangles_bottom.white": "Bas curva alba",
  "block.minecraft.banner.triangles_bottom.yellow": "Bas curva flava",
  "block.minecraft.banner.triangles_top.black": "Caput curvus niger",
  "block.minecraft.banner.triangles_top.blue": "Caput curvus caeruleus",
  "block.minecraft.banner.triangles_top.brown": "Caput curvus brunneus",
  "block.minecraft.banner.triangles_top.cyan": "Caput curvus cyaneus",
  "block.minecraft.banner.triangles_top.gray": "Caput curvus cinereus",
  "block.minecraft.banner.triangles_top.green": "Caput curvus viridis",
  "block.minecraft.banner.triangles_top.light_blue": "Caput curvus aerius",
  "block.minecraft.banner.triangles_top.light_gray": "Caput curvus canus",
  "block.minecraft.banner.triangles_top.lime": "Caput curvus prasinus",
  "block.minecraft.banner.triangles_top.magenta": "Caput curvus rubropurpurea",
  "block.minecraft.banner.triangles_top.orange": "Caput curvus aurantius",
  "block.minecraft.banner.triangles_top.pink": "Caput curvus roseus",
  "block.minecraft.banner.triangles_top.purple": "Caput curvus purpureus",
  "block.minecraft.banner.triangles_top.red": "Caput curvus ruber",
  "block.minecraft.banner.triangles_top.white": "Caput curvus albus",
  "block.minecraft.banner.triangles_top.yellow": "Caput curvus flavus",
  "block.minecraft.barrel": "Cupa",
  "block.minecraft.barrier": "Claustrum",
  "block.minecraft.basalt": "Basaltes",
  "block.minecraft.beacon": "Radiator",
  "block.minecraft.beacon.primary": "Prima potentia",
  "block.minecraft.beacon.secondary": "Secunda potentia",
  "block.minecraft.bed.no_sleep": "Nocte solum aut in tempestatibus dormire licet",
  "block.minecraft.bed.not_safe": "Dormire non potes, monstra propinqua sunt",
  "block.minecraft.bed.obstructed": "Hic lectus obstructus est",
  "block.minecraft.bed.occupied": "Hic lectus occupatus est",
  "block.minecraft.bed.too_far_away": "Dormire non potes; ab lecto nimis abes",
  "block.minecraft.bedrock": "Saxum infimum",
  "block.minecraft.bee_nest": "Nidus apium",
  "block.minecraft.beehive": "Alvearium",
  "block.minecraft.beetroots": "Betae",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Folium inclinabile latum",
  "block.minecraft.big_dripleaf_stem": "Caulis folii inclinabilis lati",
  "block.minecraft.birch_button": "Premendus betullae",
  "block.minecraft.birch_door": "Ostium betulae",
  "block.minecraft.birch_fence": "Saepes betullae",
  "block.minecraft.birch_fence_gate": "Foris betullae",
  "block.minecraft.birch_hanging_sign": "Titulus pendens betullae",
  "block.minecraft.birch_leaves": "Folia betullae",
  "block.minecraft.birch_log": "Truncus betullae",
  "block.minecraft.birch_planks": "Tabulae betullae",
  "block.minecraft.birch_pressure_plate": "Tabula premenda betullae",
  "block.minecraft.birch_sapling": "Arbuscula betullae",
  "block.minecraft.birch_shelf": "Pegma betullae",
  "block.minecraft.birch_sign": "Titulus betullae",
  "block.minecraft.birch_slab": "Gradus betullae",
  "block.minecraft.birch_stairs": "Scalae betullae",
  "block.minecraft.birch_trapdoor": "Ostium horizontale betulae",
  "block.minecraft.birch_wall_hanging_sign": "Titulus pendens muralis betullae",
  "block.minecraft.birch_wall_sign": "Titulus muralis betullae",
  "block.minecraft.birch_wood": "Lignum betullae",
  "block.minecraft.black_banner": "Vexillum nigrum",
  "block.minecraft.black_bed": "Lectus niger",
  "block.minecraft.black_candle": "Candela nigra",
  "block.minecraft.black_candle_cake": "Placenta cum candela nigra",
  "block.minecraft.black_carpet": "Tapes niger",
  "block.minecraft.black_concrete": "Opus caementicium nigrum",
  "block.minecraft.black_concrete_powder": "Caementum nigrum",
  "block.minecraft.black_glazed_terracotta": "Terra cocta smaltata nigra",
  "block.minecraft.black_shulker_box": "Capsa shulker nigra",
  "block.minecraft.black_stained_glass": "Vitrum tinctum nigrum",
  "block.minecraft.black_stained_glass_pane": "Fenestra vitrea tincta nigra",
  "block.minecraft.black_terracotta": "Terra cocta nigra",
  "block.minecraft.black_wool": "Lana nigra",
  "block.minecraft.blackstone": "Saxum nigrum",
  "block.minecraft.blackstone_slab": "Gradus saxi nigri",
  "block.minecraft.blackstone_stairs": "Scalae saxi nigri",
  "block.minecraft.blackstone_wall": "Murus saxi nigri",
  "block.minecraft.blast_furnace": "Caminus",
  "block.minecraft.blue_banner": "Vexillum venetum",
  "block.minecraft.blue_bed": "Lectus caeruleus",
  "block.minecraft.blue_candle": "Candela caerulea",
  "block.minecraft.blue_candle_cake": "Placenta cum candela caerulea",
  "block.minecraft.blue_carpet": "Tapes caeruleus",
  "block.minecraft.blue_concrete": "Opus caementicium caeruleum",
  "block.minecraft.blue_concrete_powder": "Caementum caeruleum",
  "block.minecraft.blue_glazed_terracotta": "Terra cocta smaltata caerulea",
  "block.minecraft.blue_ice": "Glacies caerulea",
  "block.minecraft.blue_orchid": "Orchis caerulea",
  "block.minecraft.blue_shulker_box": "Capsa shulker caerulea",
  "block.minecraft.blue_stained_glass": "Vitrum tinctum caeruleum",
  "block.minecraft.blue_stained_glass_pane": "Fenestra vitrea tincta caerulea",
  "block.minecraft.blue_terracotta": "Terra cocta caerulea",
  "block.minecraft.blue_wool": "Lana caerulea",
  "block.minecraft.bone_block": "Cubus osseus",
  "block.minecraft.bookshelf": "Armarium",
  "block.minecraft.brain_coral": "Corallium ramosum",
  "block.minecraft.brain_coral_block": "Cubus corallii ramosii",
  "block.minecraft.brain_coral_fan": "Gorgonia ramosa",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia ramosa horizontalis",
  "block.minecraft.brewing_stand": "Mixtarius",
  "block.minecraft.brick_slab": "Gradus latericius",
  "block.minecraft.brick_stairs": "Scalae latericiae",
  "block.minecraft.brick_wall": "Murus latericius",
  "block.minecraft.bricks": "Lateres",
  "block.minecraft.brown_banner": "Vexillum brunneum",
  "block.minecraft.brown_bed": "Lectus brunneus",
  "block.minecraft.brown_candle": "Candela brunnea",
  "block.minecraft.brown_candle_cake": "Placenta cum candela brunnea",
  "block.minecraft.brown_carpet": "Tapes brunneus",
  "block.minecraft.brown_concrete": "Opus caementicium brunneum",
  "block.minecraft.brown_concrete_powder": "Caementum brunneum",
  "block.minecraft.brown_glazed_terracotta": "Terra cocta smaltata brunnea",
  "block.minecraft.brown_mushroom": "Fungus brunneus",
  "block.minecraft.brown_mushroom_block": "Cubus fungi bruni",
  "block.minecraft.brown_shulker_box": "Capsa shulker brunnea",
  "block.minecraft.brown_stained_glass": "Vitrum tinctum brunneum",
  "block.minecraft.brown_stained_glass_pane": "Fenestra vitrea tincta brunea",
  "block.minecraft.brown_terracotta": "Terra cocta brunnea",
  "block.minecraft.brown_wool": "Lana brunnea",
  "block.minecraft.bubble_column": "Bullae",
  "block.minecraft.bubble_coral": "Corallium bullatum",
  "block.minecraft.bubble_coral_block": "Cubus corallii bullati",
  "block.minecraft.bubble_coral_fan": "Gorgonia bullata",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia bullata horizontalis",
  "block.minecraft.budding_amethyst": "Amethystus gemmans",
  "block.minecraft.bush": "Frutex",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Flos cacti",
  "block.minecraft.cake": "Placenta",
  "block.minecraft.calcite": "Asbertites",
  "block.minecraft.calibrated_sculk_sensor": "Sculk metiens",
  "block.minecraft.campfire": "Focus",
  "block.minecraft.candle": "Candela",
  "block.minecraft.candle_cake": "Placenta cum candela",
  "block.minecraft.carrots": "Carotae",
  "block.minecraft.cartography_table": "Mensa chartographiae",
  "block.minecraft.carved_pumpkin": "Curcurbita sculpta",
  "block.minecraft.cauldron": "Cortina",
  "block.minecraft.cave_air": "Aer speluncarum",
  "block.minecraft.cave_vines": "Vineae cavernarum",
  "block.minecraft.cave_vines_plant": "Stirps vinearum cavernarum",
  "block.minecraft.chain": "Catena",
  "block.minecraft.chain_command_block": "Cubus iussorum concatenatus",
  "block.minecraft.cherry_button": "Premendus cerasi",
  "block.minecraft.cherry_door": "Ostium cerasi",
  "block.minecraft.cherry_fence": "Saepes cerasi",
  "block.minecraft.cherry_fence_gate": "Foris cerasi",
  "block.minecraft.cherry_hanging_sign": "Titulus pendens cerasi",
  "block.minecraft.cherry_leaves": "Folia cerasi",
  "block.minecraft.cherry_log": "Truncus cerasi",
  "block.minecraft.cherry_planks": "Tabulae cerasi",
  "block.minecraft.cherry_pressure_plate": "Tabula premenda cerasi",
  "block.minecraft.cherry_sapling": "Arbuscula cerasi",
  "block.minecraft.cherry_shelf": "Pegma cerasi",
  "block.minecraft.cherry_sign": "Titulus cerasi",
  "block.minecraft.cherry_slab": "Gradus cerasi",
  "block.minecraft.cherry_stairs": "Scalae cerasi",
  "block.minecraft.cherry_trapdoor": "Ostium horizontale cerasi",
  "block.minecraft.cherry_wall_hanging_sign": "Titulus pendens muralis cerasi",
  "block.minecraft.cherry_wall_sign": "Titulus muralis cerasi",
  "block.minecraft.cherry_wood": "Lignum cerasi",
  "block.minecraft.chest": "Cista",
  "block.minecraft.chipped_anvil": "Incus dedolatus",
  "block.minecraft.chiseled_bookshelf": "Armarium caelatum",
  "block.minecraft.chiseled_copper": "Cuprum caelatum",
  "block.minecraft.chiseled_deepslate": "Lapis sectilis altus caelatus",
  "block.minecraft.chiseled_nether_bricks": "Lateres Nether caelati",
  "block.minecraft.chiseled_polished_blackstone": "Saxum nigrum politum caelatum",
  "block.minecraft.chiseled_quartz_block": "Cubus crystallinus caelatus",
  "block.minecraft.chiseled_red_sandstone": "Lapis harenarius ruber caelatus",
  "block.minecraft.chiseled_resin_bricks": "Lateres resinae caelati",
  "block.minecraft.chiseled_sandstone": "Lapis harenarius caelatus",
  "block.minecraft.chiseled_stone_bricks": "Lateres saxei caelati",
  "block.minecraft.chiseled_tuff": "Tophus caelatus",
  "block.minecraft.chiseled_tuff_bricks": "Lateres tophi caelati",
  "block.minecraft.chorus_flower": "Flos chori",
  "block.minecraft.chorus_plant": "Caulis chori",
  "block.minecraft.clay": "Argilla",
  "block.minecraft.closed_eyeblossom": "Floculus clausus",
  "block.minecraft.coal_block": "Cubus carbonarius",
  "block.minecraft.coal_ore": "Aes carbonarium",
  "block.minecraft.coarse_dirt": "Humus asper",
  "block.minecraft.cobbled_deepslate": "Lapilli lapidis sectilis alti",
  "block.minecraft.cobbled_deepslate_slab": "Gradus lapillorum lapidis sectilis alti",
  "block.minecraft.cobbled_deepslate_stairs": "Scalae lapillorum lapidis sectilis alti",
  "block.minecraft.cobbled_deepslate_wall": "Murus lapillorum lapidis sectilis alti",
  "block.minecraft.cobblestone": "Lapilli",
  "block.minecraft.cobblestone_slab": "Gradus lapillorum",
  "block.minecraft.cobblestone_stairs": "Scalae lapideae",
  "block.minecraft.cobblestone_wall": "Murus lapideus",
  "block.minecraft.cobweb": "Araneum",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Cubus iussorum",
  "block.minecraft.comparator": "Comparatrum redstone",
  "block.minecraft.composter": "Compostiera",
  "block.minecraft.conduit": "Conductus",
  "block.minecraft.copper_bars": "Cancelli cuprei",
  "block.minecraft.copper_block": "Cubus cupreus",
  "block.minecraft.copper_bulb": "Lumen cupreum",
  "block.minecraft.copper_chain": "Catena cuprea",
  "block.minecraft.copper_chest": "Cista cuprea",
  "block.minecraft.copper_door": "Ostium cupreum",
  "block.minecraft.copper_golem_statue": "Statua automati cuprei",
  "block.minecraft.copper_grate": "Clathri cuprei",
  "block.minecraft.copper_lantern": "Lanterna cuprea",
  "block.minecraft.copper_ore": "Aes cupreum",
  "block.minecraft.copper_torch": "Fax cuprea",
  "block.minecraft.copper_trapdoor": "Ostium horizontale cupreum",
  "block.minecraft.copper_wall_torch": "Fax muralis cupreae",
  "block.minecraft.cornflower": "Cyanus",
  "block.minecraft.cracked_deepslate_bricks": "Lateres lapidis sectilis alti rimosi",
  "block.minecraft.cracked_deepslate_tiles": "Laterculi lapidis sectilis alti rimosi",
  "block.minecraft.cracked_nether_bricks": "Lateres Nether rimosi",
  "block.minecraft.cracked_polished_blackstone_bricks": "Lateres saxi nigri politi rimosi",
  "block.minecraft.cracked_stone_bricks": "Lateres saxei rimosi",
  "block.minecraft.crafter": "Fabricator",
  "block.minecraft.crafting_table": "Mensa fabricationis",
  "block.minecraft.creaking_heart": "Cor crepacis",
  "block.minecraft.creeper_head": "Caput creeper",
  "block.minecraft.creeper_wall_head": "Caput creeper murale",
  "block.minecraft.crimson_button": "Premendus coccinus",
  "block.minecraft.crimson_door": "Ostium coccinum",
  "block.minecraft.crimson_fence": "Saepes coccina",
  "block.minecraft.crimson_fence_gate": "Foris coccina",
  "block.minecraft.crimson_fungus": "Fungus coccinus",
  "block.minecraft.crimson_hanging_sign": "Titulus pendens coccinus",
  "block.minecraft.crimson_hyphae": "Hyphae coccinae",
  "block.minecraft.crimson_nylium": "Infelium coccinum",
  "block.minecraft.crimson_planks": "Tabulae coccinae",
  "block.minecraft.crimson_pressure_plate": "Tabula premenda coccina",
  "block.minecraft.crimson_roots": "Radices coccinae",
  "block.minecraft.crimson_shelf": "Pegma coccinum",
  "block.minecraft.crimson_sign": "Titulus coccinus",
  "block.minecraft.crimson_slab": "Gradus coccinus",
  "block.minecraft.crimson_stairs": "Scalae coccinae",
  "block.minecraft.crimson_stem": "Caulis coccinus",
  "block.minecraft.crimson_trapdoor": "Ostium horizontale coccinum",
  "block.minecraft.crimson_wall_hanging_sign": "Titulus pendens muralis coccinus",
  "block.minecraft.crimson_wall_sign": "Titulus muralis coccinus",
  "block.minecraft.crying_obsidian": "Lapis obsidianus flens",
  "block.minecraft.cut_copper": "Cuprum scalptus",
  "block.minecraft.cut_copper_slab": "Gradus cupri scalpti",
  "block.minecraft.cut_copper_stairs": "Scalae cupri scalpti",
  "block.minecraft.cut_red_sandstone": "Lapis harenarius ruber scalptus",
  "block.minecraft.cut_red_sandstone_slab": "Gradus lapidis rubri harenarii scalpti",
  "block.minecraft.cut_sandstone": "Lapis harenarius scalptus",
  "block.minecraft.cut_sandstone_slab": "Gradus lapidis harenarii scalpti",
  "block.minecraft.cyan_banner": "Vexillum cyaneum",
  "block.minecraft.cyan_bed": "Lectus cyaneus",
  "block.minecraft.cyan_candle": "Candela cyanea",
  "block.minecraft.cyan_candle_cake": "Placenta cum candela cyanea",
  "block.minecraft.cyan_carpet": "Tapes cyaneus",
  "block.minecraft.cyan_concrete": "Opus caementicium cyaneum",
  "block.minecraft.cyan_concrete_powder": "Caementum cyaneum",
  "block.minecraft.cyan_glazed_terracotta": "Terra cocta smaltata cyanea",
  "block.minecraft.cyan_shulker_box": "Capsa shulker cyanea",
  "block.minecraft.cyan_stained_glass": "Vitrum tinctum cyaneum",
  "block.minecraft.cyan_stained_glass_pane": "Fenestra vitrea tincta cyanea",
  "block.minecraft.cyan_terracotta": "Terra cocta cyanea",
  "block.minecraft.cyan_wool": "Lana cyanea",
  "block.minecraft.damaged_anvil": "Incus fractus",
  "block.minecraft.dandelion": "Taraxacum",
  "block.minecraft.dark_oak_button": "Premendus quercus nigrae",
  "block.minecraft.dark_oak_door": "Ostium quercus nigrae",
  "block.minecraft.dark_oak_fence": "Saepes quercus nigrae",
  "block.minecraft.dark_oak_fence_gate": "Foris quercus nigrae",
  "block.minecraft.dark_oak_hanging_sign": "Titulus pendens quercus nigrae",
  "block.minecraft.dark_oak_leaves": "Folia quercus nigrae",
  "block.minecraft.dark_oak_log": "Truncus quercus nigrae",
  "block.minecraft.dark_oak_planks": "Tabulae quercus nigrae",
  "block.minecraft.dark_oak_pressure_plate": "Tabula premenda quercus nigrae",
  "block.minecraft.dark_oak_sapling": "Arbuscula quercus nigrae",
  "block.minecraft.dark_oak_shelf": "Pegma quercus nigrae",
  "block.minecraft.dark_oak_sign": "Titulus quercus nigrae",
  "block.minecraft.dark_oak_slab": "Gradus quercus nigrae",
  "block.minecraft.dark_oak_stairs": "Scalae quercus nigrae",
  "block.minecraft.dark_oak_trapdoor": "Ostium horizontale quercus nigrae",
  "block.minecraft.dark_oak_wall_hanging_sign": "Titulus pendens muralis quercus nigrae",
  "block.minecraft.dark_oak_wall_sign": "Titulus muralis quercus nigrae",
  "block.minecraft.dark_oak_wood": "Lignum quercus nigrae",
  "block.minecraft.dark_prismarine": "Prismarina obscura",
  "block.minecraft.dark_prismarine_slab": "Gradus prismarinus obscurus",
  "block.minecraft.dark_prismarine_stairs": "Scalae prismarinae obscurae",
  "block.minecraft.daylight_detector": "Senstrum lucis diei",
  "block.minecraft.dead_brain_coral": "Corallium ramosum mortuum",
  "block.minecraft.dead_brain_coral_block": "Cubus corallii ramosi mortui",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia ramosa mortua",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia ramosa horizontalis mortua",
  "block.minecraft.dead_bubble_coral": "Corallium bullatum mortuum",
  "block.minecraft.dead_bubble_coral_block": "Cubus corallii bullati mortui",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia bullata mortua",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia bullata horizontalis mortua",
  "block.minecraft.dead_bush": "Frutex mortuus",
  "block.minecraft.dead_fire_coral": "Corallium ignicolorum mortuum",
  "block.minecraft.dead_fire_coral_block": "Cubus corallii ignicolori mortui",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia ignicolora mortua",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia ignicolora horizontalis mortua",
  "block.minecraft.dead_horn_coral": "Corallium cornutum mortuum",
  "block.minecraft.dead_horn_coral_block": "Cubus corallii cornuti mortui",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia cornuta mortua",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia cornuta horizontalis mortua",
  "block.minecraft.dead_tube_coral": "Corallium tubulatum mortuum",
  "block.minecraft.dead_tube_coral_block": "Cubus corallii tubulati mortui",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia tubulata mortua",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia tubulata horizontalis mortua",
  "block.minecraft.decorated_pot": "Vas pictum",
  "block.minecraft.deepslate": "Lapis sectilis alti",
  "block.minecraft.deepslate_brick_slab": "Gradus laterum lapidis sectilis alti",
  "block.minecraft.deepslate_brick_stairs": "Scalae laterum lapidis sectilis alti",
  "block.minecraft.deepslate_brick_wall": "Murus laterum lapidis sectilis alti",
  "block.minecraft.deepslate_bricks": "Lateres lapidis sectilis alti",
  "block.minecraft.deepslate_coal_ore": "Aes carbonarium in lapide sectili alto",
  "block.minecraft.deepslate_copper_ore": "Aes cupreum in lapide sectili alto",
  "block.minecraft.deepslate_diamond_ore": "Aes adamantinum in lapide sectili alto",
  "block.minecraft.deepslate_emerald_ore": "Aes smaragdinum in lapide sectili alto",
  "block.minecraft.deepslate_gold_ore": "Aes aureum in lapide sectili alto",
  "block.minecraft.deepslate_iron_ore": "Aes ferreum in lapide sectili alto",
  "block.minecraft.deepslate_lapis_ore": "Aes lapidis lazuli in lapide sectile alto",
  "block.minecraft.deepslate_redstone_ore": "Aes redstone in lapide sectili alto",
  "block.minecraft.deepslate_tile_slab": "Gradus laterculorum lapidis sectilis alti",
  "block.minecraft.deepslate_tile_stairs": "Scalae laterculorum lapidis sectilis alti",
  "block.minecraft.deepslate_tile_wall": "Murus laterculorum lapidis sectilis alti",
  "block.minecraft.deepslate_tiles": "Laterculi lapidis sectilis alti",
  "block.minecraft.detector_rail": "Ferrivia percipens",
  "block.minecraft.diamond_block": "Cubus adamantinus",
  "block.minecraft.diamond_ore": "Aes adamantinum",
  "block.minecraft.diorite": "Diorites",
  "block.minecraft.diorite_slab": "Gradus dioritae",
  "block.minecraft.diorite_stairs": "Scalae dioriteae",
  "block.minecraft.diorite_wall": "Murus dioritae",
  "block.minecraft.dirt": "Humus",
  "block.minecraft.dirt_path": "Semita terrena",
  "block.minecraft.dispenser": "Distributor",
  "block.minecraft.dragon_egg": "Ovum draconis",
  "block.minecraft.dragon_head": "Caput draconis",
  "block.minecraft.dragon_wall_head": "Caput draconis murale",
  "block.minecraft.dried_ghast": "Ghast siccus",
  "block.minecraft.dried_kelp_block": "Cubus algarum siccarum",
  "block.minecraft.dripstone_block": "Cubus saxi stillantis",
  "block.minecraft.dropper": "Demittetrum",
  "block.minecraft.emerald_block": "Cubus smaragdinus",
  "block.minecraft.emerald_ore": "Aes smaragdinum",
  "block.minecraft.enchanting_table": "Mensa incantandi",
  "block.minecraft.end_gateway": "Transitus End",
  "block.minecraft.end_portal": "Porta End",
  "block.minecraft.end_portal_frame": "Replum portae End",
  "block.minecraft.end_rod": "Virga End",
  "block.minecraft.end_stone": "Lapis End",
  "block.minecraft.end_stone_brick_slab": "Gradus laterum lapidis End",
  "block.minecraft.end_stone_brick_stairs": "Scalae laterum lapidis End",
  "block.minecraft.end_stone_brick_wall": "Murus laterum lapidis End",
  "block.minecraft.end_stone_bricks": "Lateres lapidis End",
  "block.minecraft.ender_chest": "Cista Ender",
  "block.minecraft.exposed_chiseled_copper": "Cuprum caelatum obvium",
  "block.minecraft.exposed_copper": "Cuprum obvium",
  "block.minecraft.exposed_copper_bars": "Cancelli cuprei obvii",
  "block.minecraft.exposed_copper_bulb": "Lumen cupreum obvium",
  "block.minecraft.exposed_copper_chain": "Catena cuprea obvia",
  "block.minecraft.exposed_copper_chest": "Cista cuprea obvia",
  "block.minecraft.exposed_copper_door": "Ostium cupreum obvium",
  "block.minecraft.exposed_copper_golem_statue": "Statua automati cuprei obvii",
  "block.minecraft.exposed_copper_grate": "Clathri cuprei obvii",
  "block.minecraft.exposed_copper_lantern": "Lanterna cuprea obvia",
  "block.minecraft.exposed_copper_trapdoor": "Ostium horizontale cupreum obvium",
  "block.minecraft.exposed_cut_copper": "Cuprum scalptum obvium",
  "block.minecraft.exposed_cut_copper_slab": "Gradus cupri scalpti obvius",
  "block.minecraft.exposed_cut_copper_stairs": "Scalae cupri scalpti obviae",
  "block.minecraft.exposed_lightning_rod": "Virga fulmina attrahens obvia",
  "block.minecraft.farmland": "Terra arata",
  "block.minecraft.fern": "Filix",
  "block.minecraft.fire": "Ignis",
  "block.minecraft.fire_coral": "Corallium ignicolorum",
  "block.minecraft.fire_coral_block": "Cubus corallii ignicolori",
  "block.minecraft.fire_coral_fan": "Gorgonia ignicolora",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia ignicolora horizontalis",
  "block.minecraft.firefly_bush": "Frutex cicindelarum",
  "block.minecraft.fletching_table": "Mensa sagittationis",
  "block.minecraft.flower_pot": "Vas",
  "block.minecraft.flowering_azalea": "Rhododendron floridum",
  "block.minecraft.flowering_azalea_leaves": "Folia rhododendri floridi",
  "block.minecraft.frogspawn": "Ova ranae",
  "block.minecraft.frosted_ice": "Glacies fragilis",
  "block.minecraft.furnace": "Fornax",
  "block.minecraft.gilded_blackstone": "Saxum nigrum aurifer",
  "block.minecraft.glass": "Vitrum",
  "block.minecraft.glass_pane": "Fenestra vitrea",
  "block.minecraft.glow_lichen": "Lichen lucidus",
  "block.minecraft.glowstone": "Lucilapis",
  "block.minecraft.gold_block": "Cubus aureus",
  "block.minecraft.gold_ore": "Aes aureum",
  "block.minecraft.golden_dandelion": "Taraxacum aureum",
  "block.minecraft.granite": "Granitum",
  "block.minecraft.granite_slab": "Gradus graniteus",
  "block.minecraft.granite_stairs": "Scalae graniteae",
  "block.minecraft.granite_wall": "Murus graniteus",
  "block.minecraft.grass": "Gramen",
  "block.minecraft.grass_block": "Cubus graminis",
  "block.minecraft.gravel": "Glarea",
  "block.minecraft.gray_banner": "Vexillum cinereum",
  "block.minecraft.gray_bed": "Lectus cinereus",
  "block.minecraft.gray_candle": "Candela cinerea",
  "block.minecraft.gray_candle_cake": "Placenta cum candela cinerea",
  "block.minecraft.gray_carpet": "Tapes cinereus",
  "block.minecraft.gray_concrete": "Opus caementicium cinereum",
  "block.minecraft.gray_concrete_powder": "Caementum cinereum",
  "block.minecraft.gray_glazed_terracotta": "Terra cocta smaltata cinerea",
  "block.minecraft.gray_shulker_box": "Capsa shulker cinerea",
  "block.minecraft.gray_stained_glass": "Vitrum tinctum cinereum",
  "block.minecraft.gray_stained_glass_pane": "Fenestra vitrea tincta cinerea",
  "block.minecraft.gray_terracotta": "Terra cocta cinerea",
  "block.minecraft.gray_wool": "Lana cinerea",
  "block.minecraft.green_banner": "Vexillum viride",
  "block.minecraft.green_bed": "Lectus viridis",
  "block.minecraft.green_candle": "Candela viridis",
  "block.minecraft.green_candle_cake": "Placenta cum candela viridi",
  "block.minecraft.green_carpet": "Tapes viridis",
  "block.minecraft.green_concrete": "Opus caementicium viride",
  "block.minecraft.green_concrete_powder": "Caementum viride",
  "block.minecraft.green_glazed_terracotta": "Terra cocta smaltata viridis",
  "block.minecraft.green_shulker_box": "Capsa shulker viridis",
  "block.minecraft.green_stained_glass": "Vitrum tinctum viride",
  "block.minecraft.green_stained_glass_pane": "Fenestra vitrea tincta viridis",
  "block.minecraft.green_terracotta": "Terra cocta viridis",
  "block.minecraft.green_wool": "Lana viridis",
  "block.minecraft.grindstone": "Cos",
  "block.minecraft.hanging_roots": "Radices pensiles",
  "block.minecraft.hay_block": "Fascis faeni",
  "block.minecraft.heavy_core": "Nucleus ponderosus",
  "block.minecraft.heavy_weighted_pressure_plate": "Tabula premenda molibus magnis",
  "block.minecraft.honey_block": "Cubus mellis",
  "block.minecraft.honeycomb_block": "Cubus favorum",
  "block.minecraft.hopper": "Infundibulum",
  "block.minecraft.horn_coral": "Corallium cornutum",
  "block.minecraft.horn_coral_block": "Cubus corallii cornuti",
  "block.minecraft.horn_coral_fan": "Gorgonia cornuta",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia cornuta horizontalis",
  "block.minecraft.ice": "Glacies",
  "block.minecraft.infested_chiseled_stone_bricks": "Lateres saxei caelati infestati",
  "block.minecraft.infested_cobblestone": "Lapilli infestati",
  "block.minecraft.infested_cracked_stone_bricks": "Lateres saxei rimosi infestati",
  "block.minecraft.infested_deepslate": "Lapis sectilis altus infestus",
  "block.minecraft.infested_mossy_stone_bricks": "Lateres saxei muscosi infestati",
  "block.minecraft.infested_stone": "Saxum infestatum",
  "block.minecraft.infested_stone_bricks": "Lateres saxei infestati",
  "block.minecraft.iron_bars": "Cancelli ferrei",
  "block.minecraft.iron_block": "Cubus ferreus",
  "block.minecraft.iron_chain": "Catena ferrea",
  "block.minecraft.iron_door": "Ianua ferrea",
  "block.minecraft.iron_ore": "Aes ferreum",
  "block.minecraft.iron_trapdoor": "Ostium horizontale ferreum",
  "block.minecraft.jack_o_lantern": "Cucurbita illuminata",
  "block.minecraft.jigsaw": "Cubus iunctionis",
  "block.minecraft.jukebox": "Phonographum",
  "block.minecraft.jungle_button": "Premendus theobromatis",
  "block.minecraft.jungle_door": "Ostium theobromatis",
  "block.minecraft.jungle_fence": "Saepes theobromatis",
  "block.minecraft.jungle_fence_gate": "Foris theobromatis",
  "block.minecraft.jungle_hanging_sign": "Titulus pendens theobromatis",
  "block.minecraft.jungle_leaves": "Folia theobromatis",
  "block.minecraft.jungle_log": "Truncus theobromatis",
  "block.minecraft.jungle_planks": "Tabulae theobromatis",
  "block.minecraft.jungle_pressure_plate": "Tabula premenda theobromatis",
  "block.minecraft.jungle_sapling": "Arbuscula theobromatis",
  "block.minecraft.jungle_shelf": "Pegma theobromatis",
  "block.minecraft.jungle_sign": "Titulus theobromatis",
  "block.minecraft.jungle_slab": "Gradus theobromatis",
  "block.minecraft.jungle_stairs": "Scalae theobromatis",
  "block.minecraft.jungle_trapdoor": "Ostium horizontale theobromatis",
  "block.minecraft.jungle_wall_hanging_sign": "Titulus pendens muralis theobromatis",
  "block.minecraft.jungle_wall_sign": "Titulus muralis theobromatis",
  "block.minecraft.jungle_wood": "Lignum theobromatis",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Caulis algae",
  "block.minecraft.ladder": "Scala",
  "block.minecraft.lantern": "Lanterna",
  "block.minecraft.lapis_block": "Cubus lapidis lazuli",
  "block.minecraft.lapis_ore": "Aes lapidis lazuli",
  "block.minecraft.large_amethyst_bud": "Gemma amethystina maturior",
  "block.minecraft.large_fern": "Filix magna",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Cortina cum lava",
  "block.minecraft.leaf_litter": "Stramentum foliorum",
  "block.minecraft.lectern": "Lectrum",
  "block.minecraft.lever": "Vectis",
  "block.minecraft.light": "Lux",
  "block.minecraft.light_blue_banner": "Vexillum aerium",
  "block.minecraft.light_blue_bed": "Lectus aerius",
  "block.minecraft.light_blue_candle": "Candela aeria",
  "block.minecraft.light_blue_candle_cake": "Placenta cum candela aeria",
  "block.minecraft.light_blue_carpet": "Tapes aerius",
  "block.minecraft.light_blue_concrete": "Opus caementicium aerium",
  "block.minecraft.light_blue_concrete_powder": "Caementum aerium",
  "block.minecraft.light_blue_glazed_terracotta": "Terra cocta smaltata aeria",
  "block.minecraft.light_blue_shulker_box": "Capsa shulker aeria",
  "block.minecraft.light_blue_stained_glass": "Vitrum tinctum aerium",
  "block.minecraft.light_blue_stained_glass_pane": "Fenestra vitrea tincta aeria",
  "block.minecraft.light_blue_terracotta": "Terra cocta aeria",
  "block.minecraft.light_blue_wool": "Lana aeria",
  "block.minecraft.light_gray_banner": "Vexillum canum",
  "block.minecraft.light_gray_bed": "Lectus canus",
  "block.minecraft.light_gray_candle": "Candela cana",
  "block.minecraft.light_gray_candle_cake": "Placenta cum candela cana",
  "block.minecraft.light_gray_carpet": "Tapes canus",
  "block.minecraft.light_gray_concrete": "Opus caementicium canum",
  "block.minecraft.light_gray_concrete_powder": "Caementum canum",
  "block.minecraft.light_gray_glazed_terracotta": "Terra cocta smaltata cana",
  "block.minecraft.light_gray_shulker_box": "Capsa shulker cana",
  "block.minecraft.light_gray_stained_glass": "Vitrum tinctum canum",
  "block.minecraft.light_gray_stained_glass_pane": "Fenestra vitrea tincta cana",
  "block.minecraft.light_gray_terracotta": "Terra cocta cana",
  "block.minecraft.light_gray_wool": "Lana cana",
  "block.minecraft.light_weighted_pressure_plate": "Tabula permenda molibus parvis",
  "block.minecraft.lightning_rod": "Virga fulmina attrahens",
  "block.minecraft.lilac": "Syringa",
  "block.minecraft.lily_of_the_valley": "Convallaria",
  "block.minecraft.lily_pad": "Nymphaea",
  "block.minecraft.lime_banner": "Vexillum prasinum",
  "block.minecraft.lime_bed": "Lectus prasinus",
  "block.minecraft.lime_candle": "Candela prasina",
  "block.minecraft.lime_candle_cake": "Placenta cum candela prasina",
  "block.minecraft.lime_carpet": "Tapes prasinus",
  "block.minecraft.lime_concrete": "Opus caementicium prasinum",
  "block.minecraft.lime_concrete_powder": "Caementum prasinum",
  "block.minecraft.lime_glazed_terracotta": "Terra cocta smaltata prasina",
  "block.minecraft.lime_shulker_box": "Capsa shulker prasina",
  "block.minecraft.lime_stained_glass": "Vitrum tinctum prasinum",
  "block.minecraft.lime_stained_glass_pane": "Fenestra vitrea tincta prasina",
  "block.minecraft.lime_terracotta": "Terra cocta prasina",
  "block.minecraft.lime_wool": "Lana prasina",
  "block.minecraft.lodestone": "Magnes lapis",
  "block.minecraft.loom": "Tela",
  "block.minecraft.magenta_banner": "Vexillum rubropurpureum",
  "block.minecraft.magenta_bed": "Lectus rubropurpureus",
  "block.minecraft.magenta_candle": "Candela rubropurpurea",
  "block.minecraft.magenta_candle_cake": "Placenta cum candela rubropurpurea",
  "block.minecraft.magenta_carpet": "Tapes rubropurpurea",
  "block.minecraft.magenta_concrete": "Opus caementicium rubropurpureum",
  "block.minecraft.magenta_concrete_powder": "Caementum rubropurpureum",
  "block.minecraft.magenta_glazed_terracotta": "Terra cocta smaltata rubropurpurea",
  "block.minecraft.magenta_shulker_box": "Capsa shulker rubropurpurea",
  "block.minecraft.magenta_stained_glass": "Vitrum tinctum rubropurpureum",
  "block.minecraft.magenta_stained_glass_pane": "Fenestra vitrea tincta rubropurpurea",
  "block.minecraft.magenta_terracotta": "Terra cocta rubropurpurea",
  "block.minecraft.magenta_wool": "Lana rubropurpurea",
  "block.minecraft.magma_block": "Cubus magmatis",
  "block.minecraft.mangrove_button": "Premendum manglis",
  "block.minecraft.mangrove_door": "Ostium manglis",
  "block.minecraft.mangrove_fence": "Saepes manglis",
  "block.minecraft.mangrove_fence_gate": "Foris manglis",
  "block.minecraft.mangrove_hanging_sign": "Titulus pendens manglis",
  "block.minecraft.mangrove_leaves": "Folia manglis",
  "block.minecraft.mangrove_log": "Truncus manglis",
  "block.minecraft.mangrove_planks": "Tabulae manglis",
  "block.minecraft.mangrove_pressure_plate": "Tabula premenda manglis",
  "block.minecraft.mangrove_propagule": "Semen manglis",
  "block.minecraft.mangrove_roots": "Radices manglis",
  "block.minecraft.mangrove_shelf": "Pegma manglis",
  "block.minecraft.mangrove_sign": "Titulus manglis",
  "block.minecraft.mangrove_slab": "Gradus manglis",
  "block.minecraft.mangrove_stairs": "Scalae manglis",
  "block.minecraft.mangrove_trapdoor": "Ostium horizontale manglis",
  "block.minecraft.mangrove_wall_hanging_sign": "Titulus pendens muralis manglis",
  "block.minecraft.mangrove_wall_sign": "Titulus muralis manglis",
  "block.minecraft.mangrove_wood": "Lignum manglis",
  "block.minecraft.medium_amethyst_bud": "Gemma amethystina medie matura",
  "block.minecraft.melon": "Pepo",
  "block.minecraft.melon_stem": "Caulis peponis",
  "block.minecraft.moss_block": "Cubus musci",
  "block.minecraft.moss_carpet": "Muscus",
  "block.minecraft.mossy_cobblestone": "Lapilli muscosi",
  "block.minecraft.mossy_cobblestone_slab": "Gradus lapillorum muscosorum",
  "block.minecraft.mossy_cobblestone_stairs": "Scalae lapillorum muscosorum",
  "block.minecraft.mossy_cobblestone_wall": "Murus lapideus muscosus",
  "block.minecraft.mossy_stone_brick_slab": "Gradus laterum saxeorum muscosorum",
  "block.minecraft.mossy_stone_brick_stairs": "Scalae laterum saxeorum muscosorum",
  "block.minecraft.mossy_stone_brick_wall": "Murus laterum saxeorum muscosorum",
  "block.minecraft.mossy_stone_bricks": "Lateres saxei muscosi",
  "block.minecraft.moving_piston": "Embolus movens",
  "block.minecraft.mud": "Lutum",
  "block.minecraft.mud_brick_slab": "Gradus laterum luteorum",
  "block.minecraft.mud_brick_stairs": "Scalae laterum luteorum",
  "block.minecraft.mud_brick_wall": "Murus laterum luteorum",
  "block.minecraft.mud_bricks": "Lateres lutei",
  "block.minecraft.muddy_mangrove_roots": "Radices manglis luteosae",
  "block.minecraft.mushroom_stem": "Caulis funginus",
  "block.minecraft.mycelium": "Mycelium",
  "block.minecraft.nether_brick_fence": "Saepes laterum Nether",
  "block.minecraft.nether_brick_slab": "Gradus laterum Nether",
  "block.minecraft.nether_brick_stairs": "Scalae laterum Nether",
  "block.minecraft.nether_brick_wall": "Murus laterum Nether",
  "block.minecraft.nether_bricks": "Lateres Nether",
  "block.minecraft.nether_gold_ore": "Aes aureum Nether",
  "block.minecraft.nether_portal": "Porta Nether",
  "block.minecraft.nether_quartz_ore": "Aes crystalli Nether",
  "block.minecraft.nether_sprouts": "Pampini Nether",
  "block.minecraft.nether_wart": "Verruca Nether",
  "block.minecraft.nether_wart_block": "Cubus verrucarum Nether",
  "block.minecraft.netherite_block": "Cubus Netheritae",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Cubus musicus",
  "block.minecraft.oak_button": "Premendus querceus",
  "block.minecraft.oak_door": "Ostium querceum",
  "block.minecraft.oak_fence": "Saepes quercea",
  "block.minecraft.oak_fence_gate": "Foris quercea",
  "block.minecraft.oak_hanging_sign": "Titulus pendens querceus",
  "block.minecraft.oak_leaves": "Folia quercus",
  "block.minecraft.oak_log": "Truncus quercus",
  "block.minecraft.oak_planks": "Tabulae querceae",
  "block.minecraft.oak_pressure_plate": "Tabula premenda quercea",
  "block.minecraft.oak_sapling": "Arbuscula quercus",
  "block.minecraft.oak_shelf": "Pegma querceum",
  "block.minecraft.oak_sign": "Titulus querceus",
  "block.minecraft.oak_slab": "Gradus querceus",
  "block.minecraft.oak_stairs": "Scalae querceae",
  "block.minecraft.oak_trapdoor": "Ostium horizontale querceum",
  "block.minecraft.oak_wall_hanging_sign": "Titulus pendens muralis querceus",
  "block.minecraft.oak_wall_sign": "Titulus muralis querceus",
  "block.minecraft.oak_wood": "Lignum querceum",
  "block.minecraft.observer": "Spectator",
  "block.minecraft.obsidian": "Lapis obsidianus",
  "block.minecraft.ochre_froglight": "Ranaelanterna flavescens",
  "block.minecraft.ominous_banner": "Vexillum praesagum",
  "block.minecraft.open_eyeblossom": "Floculus apertus",
  "block.minecraft.orange_banner": "Vexillum aurantium",
  "block.minecraft.orange_bed": "Lectus aurantius",
  "block.minecraft.orange_candle": "Candela aurantia",
  "block.minecraft.orange_candle_cake": "Placenta cum candela aurantia",
  "block.minecraft.orange_carpet": "Tapes aurantius",
  "block.minecraft.orange_concrete": "Opus caementicium aurantium",
  "block.minecraft.orange_concrete_powder": "Caementum aurantium",
  "block.minecraft.orange_glazed_terracotta": "Terra cocta smaltata aurantia",
  "block.minecraft.orange_shulker_box": "Capsa shulker aurantia",
  "block.minecraft.orange_stained_glass": "Vitrum tinctum aurantium",
  "block.minecraft.orange_stained_glass_pane": "Fenestra vitrea tincta aurantia",
  "block.minecraft.orange_terracotta": "Terra cocta aurantia",
  "block.minecraft.orange_tulip": "Tulipa aurantia",
  "block.minecraft.orange_wool": "Lana aurantia",
  "block.minecraft.oxeye_daisy": "Leucanthemum vulgare",
  "block.minecraft.oxidized_chiseled_copper": "Cuprum caelatum robiginosum",
  "block.minecraft.oxidized_copper": "Cuprum robiginosum",
  "block.minecraft.oxidized_copper_bars": "Cancelli cuprei robiginosi",
  "block.minecraft.oxidized_copper_bulb": "Lumen cupreum robiginosum",
  "block.minecraft.oxidized_copper_chain": "Catena cuprea robiginosa",
  "block.minecraft.oxidized_copper_chest": "Cista cuprea robiginosa",
  "block.minecraft.oxidized_copper_door": "Ostium cupreum robiginosum",
  "block.minecraft.oxidized_copper_golem_statue": "Statua automati cuprei robiginosi",
  "block.minecraft.oxidized_copper_grate": "Clathri cuprei robiginosi",
  "block.minecraft.oxidized_copper_lantern": "Lanterna cuprea robiginosa",
  "block.minecraft.oxidized_copper_trapdoor": "Ostium horizontale cupreum robiginosum",
  "block.minecraft.oxidized_cut_copper": "Cuprum scalptum robiginosum",
  "block.minecraft.oxidized_cut_copper_slab": "Gradus cupri scalpti robiginosus",
  "block.minecraft.oxidized_cut_copper_stairs": "Scalae cupri scalpti robiginosae",
  "block.minecraft.oxidized_lightning_rod": "Virga fulmina attrahens robiginosa",
  "block.minecraft.packed_ice": "Glacies stipata",
  "block.minecraft.packed_mud": "Lutum stipatum",
  "block.minecraft.pale_hanging_moss": "Muscus pallidus pensilis",
  "block.minecraft.pale_moss_block": "Cubus musci pallidi",
  "block.minecraft.pale_moss_carpet": "Muscus pallidus",
  "block.minecraft.pale_oak_button": "Premendus quercus pallidae",
  "block.minecraft.pale_oak_door": "Ostium quercus pallidae",
  "block.minecraft.pale_oak_fence": "Saepes quercus pallidae",
  "block.minecraft.pale_oak_fence_gate": "Foris quercus pallidae",
  "block.minecraft.pale_oak_hanging_sign": "Titulus pendens quercus pallidae",
  "block.minecraft.pale_oak_leaves": "Folia quercus pallidae",
  "block.minecraft.pale_oak_log": "Truncus quercus pallidae",
  "block.minecraft.pale_oak_planks": "Tabulae quercus pallidae",
  "block.minecraft.pale_oak_pressure_plate": "Tabula premenda quercus pallidae",
  "block.minecraft.pale_oak_sapling": "Arbuscula quercus pallidae",
  "block.minecraft.pale_oak_shelf": "Pegma quercus pallidae",
  "block.minecraft.pale_oak_sign": "Titulus quercus pallidae",
  "block.minecraft.pale_oak_slab": "Gradus quercus pallidae",
  "block.minecraft.pale_oak_stairs": "Scalae quercus pallidae",
  "block.minecraft.pale_oak_trapdoor": "Ostium horizontale quercus pallidae",
  "block.minecraft.pale_oak_wall_hanging_sign": "Titulus pendens muralis quercus pallidae",
  "block.minecraft.pale_oak_wall_sign": "Titulus muralis quercus pallidae",
  "block.minecraft.pale_oak_wood": "Lignum quercus pallidae",
  "block.minecraft.pearlescent_froglight": "Ranaelanterna violacea",
  "block.minecraft.peony": "Paeonia",
  "block.minecraft.petrified_oak_slab": "Gradus querceus saxeus",
  "block.minecraft.piglin_head": "Caput piglin",
  "block.minecraft.piglin_wall_head": "Caput piglin murale",
  "block.minecraft.pink_banner": "Vexillum roseum",
  "block.minecraft.pink_bed": "Lectus roseus",
  "block.minecraft.pink_candle": "Candela rosea",
  "block.minecraft.pink_candle_cake": "Placenta cum candela rosea",
  "block.minecraft.pink_carpet": "Tapes roseus",
  "block.minecraft.pink_concrete": "Opus caementicium roseum",
  "block.minecraft.pink_concrete_powder": "Caementum roseum",
  "block.minecraft.pink_glazed_terracotta": "Terra cocta smaltata rosea",
  "block.minecraft.pink_petals": "Folia rosea",
  "block.minecraft.pink_shulker_box": "Capsa shulker rosea",
  "block.minecraft.pink_stained_glass": "Vitrum tinctum roseum",
  "block.minecraft.pink_stained_glass_pane": "Fenestra vitrea tincta rosa",
  "block.minecraft.pink_terracotta": "Terra cocta rosea",
  "block.minecraft.pink_tulip": "Tulipa rosea",
  "block.minecraft.pink_wool": "Lana rosea",
  "block.minecraft.piston": "Embolus",
  "block.minecraft.piston_head": "Caput emboli",
  "block.minecraft.pitcher_crop": "Nepenthis planta",
  "block.minecraft.pitcher_plant": "Nepenthes",
  "block.minecraft.player_head": "Caput lusoris",
  "block.minecraft.player_head.named": "Caput lusoris %s",
  "block.minecraft.player_wall_head": "Caput lusoris murale",
  "block.minecraft.podzol": "Subcinerarium",
  "block.minecraft.pointed_dripstone": "Saxum stillans acuminatum",
  "block.minecraft.polished_andesite": "Andesites politus",
  "block.minecraft.polished_andesite_slab": "Gradus andesitae politi",
  "block.minecraft.polished_andesite_stairs": "Scalae andesiteae politi",
  "block.minecraft.polished_basalt": "Basaltes politus",
  "block.minecraft.polished_blackstone": "Saxum nigrum politum",
  "block.minecraft.polished_blackstone_brick_slab": "Gradus laterum saxi nigri politi",
  "block.minecraft.polished_blackstone_brick_stairs": "Scalae laterum saxi nigri politi",
  "block.minecraft.polished_blackstone_brick_wall": "Murus laterum saxi nigri politi",
  "block.minecraft.polished_blackstone_bricks": "Lateres saxi nigri politi",
  "block.minecraft.polished_blackstone_button": "Premendus saxi nigri politi",
  "block.minecraft.polished_blackstone_pressure_plate": "Tabula premenda saxi nigri politi",
  "block.minecraft.polished_blackstone_slab": "Gradus saxi nigri politi",
  "block.minecraft.polished_blackstone_stairs": "Scalae saxi nigri politi",
  "block.minecraft.polished_blackstone_wall": "Murus saxi nigri politi",
  "block.minecraft.polished_deepslate": "Lapis sectilis altus politus",
  "block.minecraft.polished_deepslate_slab": "Gradus lapidis sectilis alti politi",
  "block.minecraft.polished_deepslate_stairs": "Scalae lapidis sectilis alti politi",
  "block.minecraft.polished_deepslate_wall": "Murus lapidis sectilis alti politi",
  "block.minecraft.polished_diorite": "Diorites politus",
  "block.minecraft.polished_diorite_slab": "Gradus dioriteus politus",
  "block.minecraft.polished_diorite_stairs": "Scalae dioriteae politae",
  "block.minecraft.polished_granite": "Granitum politum",
  "block.minecraft.polished_granite_slab": "Gradus graniteus politus",
  "block.minecraft.polished_granite_stairs": "Scalae graniteae politae",
  "block.minecraft.polished_tuff": "Tophus politus",
  "block.minecraft.polished_tuff_slab": "Gradus tophi politi",
  "block.minecraft.polished_tuff_stairs": "Scalae tophi politi",
  "block.minecraft.polished_tuff_wall": "Murus tophi politi",
  "block.minecraft.poppy": "Papaver",
  "block.minecraft.potatoes": "Patatae",
  "block.minecraft.potted_acacia_sapling": "Arbuscula acaciae inserta",
  "block.minecraft.potted_allium": "Allium in vase",
  "block.minecraft.potted_azalea_bush": "Rhododendron in vase",
  "block.minecraft.potted_azure_bluet": "Houstonia caerulea in vase",
  "block.minecraft.potted_bamboo": "Harundo Indica in vase",
  "block.minecraft.potted_birch_sapling": "Arbuscula betullae in vase",
  "block.minecraft.potted_blue_orchid": "Vanda coerulea in vase",
  "block.minecraft.potted_brown_mushroom": "Fungus brunus in vase",
  "block.minecraft.potted_cactus": "Cactus in vase",
  "block.minecraft.potted_cherry_sapling": "Arbuscula cerasi in vase",
  "block.minecraft.potted_closed_eyeblossom": "Floculus clausus in vase",
  "block.minecraft.potted_cornflower": "Cyanus in vase",
  "block.minecraft.potted_crimson_fungus": "Fungus coccinus in vase",
  "block.minecraft.potted_crimson_roots": "Radices coccinae in vase",
  "block.minecraft.potted_dandelion": "Taraxacum in vase",
  "block.minecraft.potted_dark_oak_sapling": "Arbuscula quercus nigrae in vase",
  "block.minecraft.potted_dead_bush": "Frutex mortuus in vase",
  "block.minecraft.potted_fern": "Filix in vase",
  "block.minecraft.potted_flowering_azalea_bush": "Rhododendron floridum in vase",
  "block.minecraft.potted_golden_dandelion": "Taraxacum aureum in vase",
  "block.minecraft.potted_jungle_sapling": "Arbuscula theobromatis in vase",
  "block.minecraft.potted_lily_of_the_valley": "Convallaria in vase",
  "block.minecraft.potted_mangrove_propagule": "Semen manglis in vase",
  "block.minecraft.potted_oak_sapling": "Arbuscula quercus in vase",
  "block.minecraft.potted_open_eyeblossom": "Floculus apertus in vase",
  "block.minecraft.potted_orange_tulip": "Tulipa aurantia in vase",
  "block.minecraft.potted_oxeye_daisy": "Leucanthemum vulgare in vase",
  "block.minecraft.potted_pale_oak_sapling": "Arbuscula quercus pallidae in vase",
  "block.minecraft.potted_pink_tulip": "Tulipa rosea in vase",
  "block.minecraft.potted_poppy": "Papaver in vase",
  "block.minecraft.potted_red_mushroom": "Fungus ruber in vase",
  "block.minecraft.potted_red_tulip": "Tulipa rubra in vase",
  "block.minecraft.potted_spruce_sapling": "Arbuscula piceae in vase",
  "block.minecraft.potted_torchflower": "Facularia in vase",
  "block.minecraft.potted_warped_fungus": "Fungus distortus in vase",
  "block.minecraft.potted_warped_roots": "Radices distortae insertae",
  "block.minecraft.potted_white_tulip": "Tulipa alba in vase",
  "block.minecraft.potted_wither_rose": "Rosa wither in vase",
  "block.minecraft.powder_snow": "Nix pulverea",
  "block.minecraft.powder_snow_cauldron": "Cortina cum nivi pulverea",
  "block.minecraft.powered_rail": "Ferrivia electrica",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Gradus laterum prismarinorum",
  "block.minecraft.prismarine_brick_stairs": "Gradus laterum prismarinorum",
  "block.minecraft.prismarine_bricks": "Lateres prismarini",
  "block.minecraft.prismarine_slab": "Gradus prismarinus",
  "block.minecraft.prismarine_stairs": "Scalae prismarinae",
  "block.minecraft.prismarine_wall": "Murus prismarinus",
  "block.minecraft.pumpkin": "Cucurbita",
  "block.minecraft.pumpkin_stem": "Caulis cucurbitae",
  "block.minecraft.purple_banner": "Vexillum purpureum",
  "block.minecraft.purple_bed": "Lectus purpureus",
  "block.minecraft.purple_candle": "Candela purpurea",
  "block.minecraft.purple_candle_cake": "Placenta cum candela purpurea",
  "block.minecraft.purple_carpet": "Tapes purpureus",
  "block.minecraft.purple_concrete": "Opus caementicium purpureum",
  "block.minecraft.purple_concrete_powder": "Caementum purpureum",
  "block.minecraft.purple_glazed_terracotta": "Terra cocta smaltata purpurea",
  "block.minecraft.purple_shulker_box": "Capsa shulker purpurea",
  "block.minecraft.purple_stained_glass": "Vitrum tinctum purpureum",
  "block.minecraft.purple_stained_glass_pane": "Fenestra vitrea tincta purpurea",
  "block.minecraft.purple_terracotta": "Terra cocta purpurea",
  "block.minecraft.purple_wool": "Lana purpurea",
  "block.minecraft.purpur_block": "Cubus purpur",
  "block.minecraft.purpur_pillar": "Columna purpur",
  "block.minecraft.purpur_slab": "Gradus purpur",
  "block.minecraft.purpur_stairs": "Scalae purpur",
  "block.minecraft.quartz_block": "Cubus crystallinum",
  "block.minecraft.quartz_bricks": "Lateres crystallini",
  "block.minecraft.quartz_pillar": "Columna crystallina",
  "block.minecraft.quartz_slab": "Gradus crystallinus",
  "block.minecraft.quartz_stairs": "Scalae crystallinae",
  "block.minecraft.rail": "Ferrivia",
  "block.minecraft.raw_copper_block": "Cubus cupri infecti",
  "block.minecraft.raw_gold_block": "Cubus auri infecti",
  "block.minecraft.raw_iron_block": "Cubus ferri infecti",
  "block.minecraft.red_banner": "Vexillum rubrum",
  "block.minecraft.red_bed": "Lectus ruber",
  "block.minecraft.red_candle": "Candela rubra",
  "block.minecraft.red_candle_cake": "Placenta cum candela rubra",
  "block.minecraft.red_carpet": "Tapes ruber",
  "block.minecraft.red_concrete": "Opus caementicium rubrum",
  "block.minecraft.red_concrete_powder": "Caementum rubrum",
  "block.minecraft.red_glazed_terracotta": "Terra cocta smaltata rubra",
  "block.minecraft.red_mushroom": "Fungus ruber",
  "block.minecraft.red_mushroom_block": "Cubus fungi rubri",
  "block.minecraft.red_nether_brick_slab": "Gradus laterum Nether rubrorum",
  "block.minecraft.red_nether_brick_stairs": "Scalae laterum Nether rubrorum",
  "block.minecraft.red_nether_brick_wall": "Murus laterum Nether rubrorum",
  "block.minecraft.red_nether_bricks": "Lateres Nether rubri",
  "block.minecraft.red_sand": "Harena rubra",
  "block.minecraft.red_sandstone": "Lapis harenarius ruber",
  "block.minecraft.red_sandstone_slab": "Gradus lapidis harenarii rubri",
  "block.minecraft.red_sandstone_stairs": "Scalae lapidis harenarii rubri",
  "block.minecraft.red_sandstone_wall": "Murus lapidis harenarii rubri",
  "block.minecraft.red_shulker_box": "Capsa shulker rubra",
  "block.minecraft.red_stained_glass": "Vitrum tinctum rubrum",
  "block.minecraft.red_stained_glass_pane": "Fenestra vitrea tincta rubra",
  "block.minecraft.red_terracotta": "Terra cocta rubra",
  "block.minecraft.red_tulip": "Tulipa rubra",
  "block.minecraft.red_wool": "Lana rubra",
  "block.minecraft.redstone_block": "Cubus redstone",
  "block.minecraft.redstone_lamp": "Lampas redstone",
  "block.minecraft.redstone_ore": "Aes redstone",
  "block.minecraft.redstone_torch": "Fax redstone",
  "block.minecraft.redstone_wall_torch": "Fax muralis redstone",
  "block.minecraft.redstone_wire": "Funis redstone",
  "block.minecraft.reinforced_deepslate": "Lapis sectilis altus firmior",
  "block.minecraft.repeater": "Iteratrum redstone",
  "block.minecraft.repeating_command_block": "Cubus iussorum iterans",
  "block.minecraft.resin_block": "Cubus resinae",
  "block.minecraft.resin_brick_slab": "Gradus laterum resinae",
  "block.minecraft.resin_brick_stairs": "Scalae laterum resinae",
  "block.minecraft.resin_brick_wall": "Murus laterum resinae",
  "block.minecraft.resin_bricks": "Lateres resinae",
  "block.minecraft.resin_clump": "Glaeba resinae",
  "block.minecraft.respawn_anchor": "Ancora renascendi",
  "block.minecraft.rooted_dirt": "Humus cum radicibus",
  "block.minecraft.rose_bush": "Frutex rosarum",
  "block.minecraft.sand": "Harena",
  "block.minecraft.sandstone": "Lapis harenarius",
  "block.minecraft.sandstone_slab": "Gradus lapidis harenarii",
  "block.minecraft.sandstone_stairs": "Scalae lapidis harenarii",
  "block.minecraft.sandstone_wall": "Murus lapidis harenarii",
  "block.minecraft.scaffolding": "Fulcimen",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk mutans",
  "block.minecraft.sculk_sensor": "Sculk sentiens",
  "block.minecraft.sculk_shrieker": "Sculk clamans",
  "block.minecraft.sculk_vein": "Vena sculk",
  "block.minecraft.sea_lantern": "Lanterna marina",
  "block.minecraft.sea_pickle": "Pyrosoma",
  "block.minecraft.seagrass": "Gramen marinum",
  "block.minecraft.set_spawn": "Hic locus renascendi tuus factus est",
  "block.minecraft.short_dry_grass": "Gramen siccum breve",
  "block.minecraft.short_grass": "Gramen breve",
  "block.minecraft.shroomlight": "Lucifungus",
  "block.minecraft.shulker_box": "Capsa shulker",
  "block.minecraft.skeleton_skull": "Calva sceleti",
  "block.minecraft.skeleton_wall_skull": "Calva sceleti muralis",
  "block.minecraft.slime_block": "Cubus muci",
  "block.minecraft.small_amethyst_bud": "Gemma amethystina nova",
  "block.minecraft.small_dripleaf": "Folium inclinabile parvum",
  "block.minecraft.smithing_table": "Mensa fabricae",
  "block.minecraft.smoker": "Fumigator",
  "block.minecraft.smooth_basalt": "Basaltes glabrus",
  "block.minecraft.smooth_quartz": "Cubus crystalli glabri",
  "block.minecraft.smooth_quartz_slab": "Gradus crystalli glabri",
  "block.minecraft.smooth_quartz_stairs": "Gradus crystalli glabri",
  "block.minecraft.smooth_red_sandstone": "Lapis harenarius ruber glaber",
  "block.minecraft.smooth_red_sandstone_slab": "Gradus lapidis harenarii rubri glabri",
  "block.minecraft.smooth_red_sandstone_stairs": "Gradus lapidis harenarii rubri glabri",
  "block.minecraft.smooth_sandstone": "Lapis harenarius glaber",
  "block.minecraft.smooth_sandstone_slab": "Gradus lapidis harenarii glabri",
  "block.minecraft.smooth_sandstone_stairs": "Gradus lapidis harenarii glabri",
  "block.minecraft.smooth_stone": "Saxum glabrum",
  "block.minecraft.smooth_stone_slab": "Gradus saxi glabri",
  "block.minecraft.sniffer_egg": "Ovum odorisequi",
  "block.minecraft.snow": "Nix",
  "block.minecraft.snow_block": "Cubus niveus",
  "block.minecraft.soul_campfire": "Focus animarum",
  "block.minecraft.soul_fire": "Ignis animarum",
  "block.minecraft.soul_lantern": "Lanterna animarum",
  "block.minecraft.soul_sand": "Harena animarum",
  "block.minecraft.soul_soil": "Humus animarum",
  "block.minecraft.soul_torch": "Fax animarum",
  "block.minecraft.soul_wall_torch": "Fax muralis animarum",
  "block.minecraft.spawn.not_valid": "Lectus vel ancora renascendi firma tibi non erant vel tui obstructi sunt",
  "block.minecraft.spawner": "Creator monstrorum",
  "block.minecraft.spawner.desc1": "Usus ovo creationis:",
  "block.minecraft.spawner.desc2": "Genus mobilis ponit",
  "block.minecraft.sponge": "Spongia",
  "block.minecraft.spore_blossom": "Flos sporas spargens",
  "block.minecraft.spruce_button": "Premendus piceae",
  "block.minecraft.spruce_door": "Ostium piceae",
  "block.minecraft.spruce_fence": "Saepes piceae",
  "block.minecraft.spruce_fence_gate": "Foris piceae",
  "block.minecraft.spruce_hanging_sign": "Titulus pendens piceae",
  "block.minecraft.spruce_leaves": "Folia piceae",
  "block.minecraft.spruce_log": "Truncus piceae",
  "block.minecraft.spruce_planks": "Tabulae piceae",
  "block.minecraft.spruce_pressure_plate": "Tabula premenda piceae",
  "block.minecraft.spruce_sapling": "Arbuscula piceae",
  "block.minecraft.spruce_shelf": "Pegma piceae",
  "block.minecraft.spruce_sign": "Titulus piceae",
  "block.minecraft.spruce_slab": "Gradus piceae",
  "block.minecraft.spruce_stairs": "Scalae piceae",
  "block.minecraft.spruce_trapdoor": "Ostium horizontale piceae",
  "block.minecraft.spruce_wall_hanging_sign": "Titulus pendens muralis piceae",
  "block.minecraft.spruce_wall_sign": "Titulus muralis piceae",
  "block.minecraft.spruce_wood": "Lignum piceae",
  "block.minecraft.sticky_piston": "Embolus tenax",
  "block.minecraft.stone": "Saxum",
  "block.minecraft.stone_brick_slab": "Gradus laterum saxeorum",
  "block.minecraft.stone_brick_stairs": "Scalae laterum saxeorum",
  "block.minecraft.stone_brick_wall": "Murus laterum saxeorum",
  "block.minecraft.stone_bricks": "Lateres saxei",
  "block.minecraft.stone_button": "Premendus saxeus",
  "block.minecraft.stone_pressure_plate": "Tabula premenda saxea",
  "block.minecraft.stone_slab": "Gradus saxeus",
  "block.minecraft.stone_stairs": "Scalae saxeae",
  "block.minecraft.stonecutter": "Saxumsecator",
  "block.minecraft.stripped_acacia_log": "Truncus acaciae decorticatus",
  "block.minecraft.stripped_acacia_wood": "Lignum acaciae decorticatum",
  "block.minecraft.stripped_bamboo_block": "Cubus harundinum Indicarum decorticatarum",
  "block.minecraft.stripped_birch_log": "Truncus betullae decorticatus",
  "block.minecraft.stripped_birch_wood": "Lignum betullae decorticatum",
  "block.minecraft.stripped_cherry_log": "Truncus cerasi decorticatus",
  "block.minecraft.stripped_cherry_wood": "Lignum cerasi decorticatum",
  "block.minecraft.stripped_crimson_hyphae": "Hyphae coccinae decorticatae",
  "block.minecraft.stripped_crimson_stem": "Caulis coccinus decorticatus",
  "block.minecraft.stripped_dark_oak_log": "Truncus quercus nigrae decorticatus",
  "block.minecraft.stripped_dark_oak_wood": "Lignum quercus nigrae decorticatum",
  "block.minecraft.stripped_jungle_log": "Truncus theobromatis decorticatus",
  "block.minecraft.stripped_jungle_wood": "Lignum theobromatis decorticatum",
  "block.minecraft.stripped_mangrove_log": "Truncus manglis decorticatus",
  "block.minecraft.stripped_mangrove_wood": "Lignum manglis decorticatum",
  "block.minecraft.stripped_oak_log": "Truncus quercus decorticatus",
  "block.minecraft.stripped_oak_wood": "Lignum querceum decorticatum",
  "block.minecraft.stripped_pale_oak_log": "Truncus quercus pallidae decorticatus",
  "block.minecraft.stripped_pale_oak_wood": "Lignum quercus pallidae decorticatum",
  "block.minecraft.stripped_spruce_log": "Truncus piceae decorticatus",
  "block.minecraft.stripped_spruce_wood": "Lignum piceae decorticatum",
  "block.minecraft.stripped_warped_hyphae": "Hyphae distortae decorticatae",
  "block.minecraft.stripped_warped_stem": "Caulis distortus decorticatus",
  "block.minecraft.structure_block": "Cubus aedifici",
  "block.minecraft.structure_void": "Inane aedificii",
  "block.minecraft.sugar_cane": "Canna sacchari",
  "block.minecraft.sunflower": "Helianthus",
  "block.minecraft.suspicious_gravel": "Glarea suspecta",
  "block.minecraft.suspicious_sand": "Harena suspecta",
  "block.minecraft.sweet_berry_bush": "Frutex bacarum dulcium",
  "block.minecraft.tall_dry_grass": "Gramen siccum procerum",
  "block.minecraft.tall_grass": "Gramen altum",
  "block.minecraft.tall_seagrass": "Gramen marinum altum",
  "block.minecraft.target": "Palus",
  "block.minecraft.terracotta": "Terra cocta",
  "block.minecraft.test_block": "Cubus probationis",
  "block.minecraft.test_instance_block": "Cubus unius probationis",
  "block.minecraft.tinted_glass": "Vitrum fuscum",
  "block.minecraft.tnt": "Dynamites",
  "block.minecraft.tnt.disabled": "Displosiones dynamitis inactivae sunt",
  "block.minecraft.torch": "Fax",
  "block.minecraft.torchflower": "Facularia",
  "block.minecraft.torchflower_crop": "Planta faculariae",
  "block.minecraft.trapped_chest": "Cista dolosa",
  "block.minecraft.trial_spawner": "Creator periculorum",
  "block.minecraft.tripwire": "Laqueus",
  "block.minecraft.tripwire_hook": "Hamus laquei",
  "block.minecraft.tube_coral": "Corallium tubulatum",
  "block.minecraft.tube_coral_block": "Cubus corallii tubulati",
  "block.minecraft.tube_coral_fan": "Gorgonia tubulata",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia tubulata horizontalis",
  "block.minecraft.tuff": "Tophus",
  "block.minecraft.tuff_brick_slab": "Gradus laterum tophi",
  "block.minecraft.tuff_brick_stairs": "Scalae laterum tophi",
  "block.minecraft.tuff_brick_wall": "Murus laterum tophi",
  "block.minecraft.tuff_bricks": "Lateres tophi",
  "block.minecraft.tuff_slab": "Gradus tophi",
  "block.minecraft.tuff_stairs": "Scalae tophi",
  "block.minecraft.tuff_wall": "Murus tophi",
  "block.minecraft.turtle_egg": "Ovum testudinis",
  "block.minecraft.twisting_vines": "Vineae contortae",
  "block.minecraft.twisting_vines_plant": "Stirps vinearum contortarum",
  "block.minecraft.vault": "Arca",
  "block.minecraft.verdant_froglight": "Ranaelanterna virescens",
  "block.minecraft.vine": "Vineae",
  "block.minecraft.void_air": "Aer inanis",
  "block.minecraft.wall_torch": "Fax muralis",
  "block.minecraft.warped_button": "Premendus distortus",
  "block.minecraft.warped_door": "Ostium distortum",
  "block.minecraft.warped_fence": "Saepes distorta",
  "block.minecraft.warped_fence_gate": "Foris distorta",
  "block.minecraft.warped_fungus": "Fungus distortus",
  "block.minecraft.warped_hanging_sign": "Titulus pendens distortus",
  "block.minecraft.warped_hyphae": "Hyphae distortae",
  "block.minecraft.warped_nylium": "Infelium distortum",
  "block.minecraft.warped_planks": "Tabulae distortae",
  "block.minecraft.warped_pressure_plate": "Tabula premenda distorta",
  "block.minecraft.warped_roots": "Radices distortae",
  "block.minecraft.warped_shelf": "Pegma distortum",
  "block.minecraft.warped_sign": "Titulus distortus",
  "block.minecraft.warped_slab": "Gradus distortus",
  "block.minecraft.warped_stairs": "Scalae distortae",
  "block.minecraft.warped_stem": "Caulis distortus",
  "block.minecraft.warped_trapdoor": "Ostium horizontale distortum",
  "block.minecraft.warped_wall_hanging_sign": "Titulus pendens muralis distortus",
  "block.minecraft.warped_wall_sign": "Titulus muralis distortus",
  "block.minecraft.warped_wart_block": "Cubus verrucarum distortarum",
  "block.minecraft.water": "Aqua",
  "block.minecraft.water_cauldron": "Cortina cum aqua",
  "block.minecraft.waxed_chiseled_copper": "Cuprum caelatum attritum",
  "block.minecraft.waxed_copper_bars": "Cancelli cuprei cerati",
  "block.minecraft.waxed_copper_block": "Cubus cupreus ceratus",
  "block.minecraft.waxed_copper_bulb": "Lumen cupreum ceratum",
  "block.minecraft.waxed_copper_chain": "Catena cuprea cerata",
  "block.minecraft.waxed_copper_chest": "Cista cuprea cerata",
  "block.minecraft.waxed_copper_door": "Ostium cupreum ceratum",
  "block.minecraft.waxed_copper_golem_statue": "Statua automati cuprei cerati",
  "block.minecraft.waxed_copper_grate": "Clathri cuprei cerati",
  "block.minecraft.waxed_copper_lantern": "Lanterna cuprea cerata",
  "block.minecraft.waxed_copper_trapdoor": "Ostium horizontale cupreum ceratum",
  "block.minecraft.waxed_cut_copper": "Cuprum scalptum ceratum",
  "block.minecraft.waxed_cut_copper_slab": "Gradus cupri scalpti ceratus",
  "block.minecraft.waxed_cut_copper_stairs": "Scalae cupri scalpti ceratae",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cuprum caelatum obvium ceratum",
  "block.minecraft.waxed_exposed_copper": "Cuprum obvium ceratum",
  "block.minecraft.waxed_exposed_copper_bars": "Cancelli cuprei obvii cerati",
  "block.minecraft.waxed_exposed_copper_bulb": "Lumen cupreum obvium ceratum",
  "block.minecraft.waxed_exposed_copper_chain": "Catena cuprea obvia cerata",
  "block.minecraft.waxed_exposed_copper_chest": "Cista cuprea obvia cerata",
  "block.minecraft.waxed_exposed_copper_door": "Ostium cupreum obvium ceratum",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Statua automati cuprei obvii cerati",
  "block.minecraft.waxed_exposed_copper_grate": "Clathri cuprei obvii cerati",
  "block.minecraft.waxed_exposed_copper_lantern": "Lanterna cuprea obvia cerata",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Ostium horizontale cupreum obvium ceratum",
  "block.minecraft.waxed_exposed_cut_copper": "Cuprum scalptum obvium ceratum",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Gradus cupri scalpti obvius ceratus",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Scalae cupri scalpti obviae ceratae",
  "block.minecraft.waxed_exposed_lightning_rod": "Virga fulmina attrahens obvia cerata",
  "block.minecraft.waxed_lightning_rod": "Virga fulmina attrahens cerata",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cupreum caelatum robiginosum ceratum",
  "block.minecraft.waxed_oxidized_copper": "Cuprum robiginosum ceratum",
  "block.minecraft.waxed_oxidized_copper_bars": "Cancelli cuprei robiginosi cerati",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lumen cupreum robiginosum ceratum",
  "block.minecraft.waxed_oxidized_copper_chain": "Catena cuprea robiginosa cerata",
  "block.minecraft.waxed_oxidized_copper_chest": "Cista cuprea robiginosa cerata",
  "block.minecraft.waxed_oxidized_copper_door": "Ostium cupreum robiginosum ceratum",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Statua automati cuprei robiginosi cerati",
  "block.minecraft.waxed_oxidized_copper_grate": "Clathri cuprei robiginosi cerati",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lanterna cuprea robiginosa cerata",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Ostium horizontale cupreum robiginosum ceratum",
  "block.minecraft.waxed_oxidized_cut_copper": "Cuprum scalptum robiginosum ceratum",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Gradus cupri scalpti robiginosus ceratus",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Scalae cupri scalpti robiginosae ceratae",
  "block.minecraft.waxed_oxidized_lightning_rod": "Virga fulmina attrahens robiginosa cerata",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cupreum caelatum attritum ceratum",
  "block.minecraft.waxed_weathered_copper": "Cuprum attritum ceratum",
  "block.minecraft.waxed_weathered_copper_bars": "Cancelli cuprei attriti cerati",
  "block.minecraft.waxed_weathered_copper_bulb": "Lumen cupreum attritum ceratum",
  "block.minecraft.waxed_weathered_copper_chain": "Catena cuprea attrita cerata",
  "block.minecraft.waxed_weathered_copper_chest": "Cista cuprea attrita cerata",
  "block.minecraft.waxed_weathered_copper_door": "Ostium cupreum attritum ceratum",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Statua automati cuprei attriti cerati",
  "block.minecraft.waxed_weathered_copper_grate": "Clathri cuprei attriti cerati",
  "block.minecraft.waxed_weathered_copper_lantern": "Lanterna cuprea attrita cerata",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Ostium horizontale cupreum attritum ceratum",
  "block.minecraft.waxed_weathered_cut_copper": "Cuprum scalptum attritum ceratum",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Gradus cupri scalpti attritus ceratus",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Scalae cupri scalpti attritae ceratae",
  "block.minecraft.waxed_weathered_lightning_rod": "Virga fulmina attrahens attrita cerata",
  "block.minecraft.weathered_chiseled_copper": "Cuprum caelatum attritum",
  "block.minecraft.weathered_copper": "Cuprum attritum",
  "block.minecraft.weathered_copper_bars": "Cancelli cuprei attriti",
  "block.minecraft.weathered_copper_bulb": "Lumen cupreum attritum",
  "block.minecraft.weathered_copper_chain": "Catena cuprea attrita",
  "block.minecraft.weathered_copper_chest": "Cista cuprea attrita",
  "block.minecraft.weathered_copper_door": "Ostium cupreum attritum",
  "block.minecraft.weathered_copper_golem_statue": "Statua automati cuprei attriti",
  "block.minecraft.weathered_copper_grate": "Clathri cuprei attriti",
  "block.minecraft.weathered_copper_lantern": "Lanterna cuprea attrita",
  "block.minecraft.weathered_copper_trapdoor": "Ostium horizontale cupreum attritum",
  "block.minecraft.weathered_cut_copper": "Cuprum scalptum attritum",
  "block.minecraft.weathered_cut_copper_slab": "Gradus cupri scalpti attritus",
  "block.minecraft.weathered_cut_copper_stairs": "Scalae cupri scalpti attritae",
  "block.minecraft.weathered_lightning_rod": "Virga fulmina attrahens attrita",
  "block.minecraft.weeping_vines": "Vineae lacrimosae",
  "block.minecraft.weeping_vines_plant": "Stirps vinearum lacrimosarum",
  "block.minecraft.wet_sponge": "Spongia madida",
  "block.minecraft.wheat": "Planta frumenti",
  "block.minecraft.white_banner": "Vexillum album",
  "block.minecraft.white_bed": "Lectus albus",
  "block.minecraft.white_candle": "Candela alba",
  "block.minecraft.white_candle_cake": "Placenta cum candela alba",
  "block.minecraft.white_carpet": "Tapes albus",
  "block.minecraft.white_concrete": "Opus caementicium album",
  "block.minecraft.white_concrete_powder": "Caementum album",
  "block.minecraft.white_glazed_terracotta": "Terra cocta smaltata alba",
  "block.minecraft.white_shulker_box": "Capsa shulker alba",
  "block.minecraft.white_stained_glass": "Vitrum tinctum album",
  "block.minecraft.white_stained_glass_pane": "Fenestra vitrea tincta alba",
  "block.minecraft.white_terracotta": "Terra cocta alba",
  "block.minecraft.white_tulip": "Tulipa alba",
  "block.minecraft.white_wool": "Lana alba",
  "block.minecraft.wildflowers": "Flores silvestrum",
  "block.minecraft.wither_rose": "Rosa wither",
  "block.minecraft.wither_skeleton_skull": "Calva sceleti wither",
  "block.minecraft.wither_skeleton_wall_skull": "Calva sceleti wither muralis",
  "block.minecraft.yellow_banner": "Vexillum flauum",
  "block.minecraft.yellow_bed": "Lectus flavus",
  "block.minecraft.yellow_candle": "Candela flava",
  "block.minecraft.yellow_candle_cake": "Placenta cum candela flava",
  "block.minecraft.yellow_carpet": "Tapes flavus",
  "block.minecraft.yellow_concrete": "Opus caementicium flavum",
  "block.minecraft.yellow_concrete_powder": "Caementum flavum",
  "block.minecraft.yellow_glazed_terracotta": "Terra cocta smaltata flava",
  "block.minecraft.yellow_shulker_box": "Capsa shulker flava",
  "block.minecraft.yellow_stained_glass": "Vitrum tinctum flavum",
  "block.minecraft.yellow_stained_glass_pane": "Fenestra vitrea tincta flava",
  "block.minecraft.yellow_terracotta": "Terra cocta flava",
  "block.minecraft.yellow_wool": "Lana flava",
  "block.minecraft.zombie_head": "Caput resurrecti",
  "block.minecraft.zombie_wall_head": "Caput ressurrecti murale",
  "item.minecraft.acacia_boat": "Ratis acaciae",
  "item.minecraft.acacia_chest_boat": "Ratis acaciae cum cista",
  "item.minecraft.allay_spawn_egg": "Ovum creationis relevatoris",
  "item.minecraft.amethyst_shard": "Fragmentum amethystinum",
  "item.minecraft.angler_pottery_shard": "Testa cum harundine picta",
  "item.minecraft.angler_pottery_sherd": "Testa cum harundine picta",
  "item.minecraft.apple": "Malum",
  "item.minecraft.archer_pottery_shard": "Testa cum arco picto",
  "item.minecraft.archer_pottery_sherd": "Testa cum arco picto",
  "item.minecraft.armadillo_scute": "Squama dasypodis",
  "item.minecraft.armadillo_spawn_egg": "Ovum creationis dasypodis",
  "item.minecraft.armor_stand": "Statumen armorum",
  "item.minecraft.arms_up_pottery_shard": "Testa cum brachiis pictis",
  "item.minecraft.arms_up_pottery_sherd": "Testa cum brachiis pictis",
  "item.minecraft.arrow": "Sagitta",
  "item.minecraft.axolotl_bucket": "Hama cum salamandra mexicana",
  "item.minecraft.axolotl_spawn_egg": "Ovum creationis salamandrae mexicanae",
  "item.minecraft.baked_potato": "Patata cocta",
  "item.minecraft.bamboo_chest_raft": "Ratis harundinum Indicarum cum cista",
  "item.minecraft.bamboo_raft": "Ratis harundinum Indicarum",
  "item.minecraft.bat_spawn_egg": "Ovum creationis vespertilionis",
  "item.minecraft.bee_spawn_egg": "Ovum creationis apis",
  "item.minecraft.beef": "Bubula cruda",
  "item.minecraft.beetroot": "Beta",
  "item.minecraft.beetroot_seeds": "Semina betaceae",
  "item.minecraft.beetroot_soup": "Ius betaceum",
  "item.minecraft.birch_boat": "Ratis betullae",
  "item.minecraft.birch_chest_boat": "Ratis betullae cum cista",
  "item.minecraft.black_bundle": "Sarcina nigra",
  "item.minecraft.black_dye": "Tinctura nigra",
  "item.minecraft.black_harness": "Capistrum nigrum",
  "item.minecraft.blade_pottery_shard": "Testa cum ense picto",
  "item.minecraft.blade_pottery_sherd": "Testa cum ense picto",
  "item.minecraft.blaze_powder": "Pulvis flammifer",
  "item.minecraft.blaze_rod": "Virga flammifera",
  "item.minecraft.blaze_spawn_egg": "Ovum creationis flammiferi",
  "item.minecraft.blue_bundle": "Sarcina caerulea",
  "item.minecraft.blue_dye": "Tinctura caerulea",
  "item.minecraft.blue_egg": "Ovum lividum",
  "item.minecraft.blue_harness": "Capistrum caeruleum",
  "item.minecraft.bogged_spawn_egg": "Ovum creationis paludivagi",
  "item.minecraft.bolt_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ornamentum tegminis cum clavis",
  "item.minecraft.bone": "Os",
  "item.minecraft.bone_meal": "Ossa molita",
  "item.minecraft.book": "Liber",
  "item.minecraft.bordure_indented_banner_pattern": "Finitio curvum exemplar vexilli",
  "item.minecraft.bow": "Arcus",
  "item.minecraft.bowl": "Patera",
  "item.minecraft.bread": "Panis",
  "item.minecraft.breeze_rod": "Virga ventifera",
  "item.minecraft.breeze_spawn_egg": "Ovum creationis ventiferi",
  "item.minecraft.brewer_pottery_shard": "Testa cum potione picta",
  "item.minecraft.brewer_pottery_sherd": "Testa cum potione picta",
  "item.minecraft.brewing_stand": "Mixtarius",
  "item.minecraft.brick": "Later",
  "item.minecraft.brown_bundle": "Sarcina brunnea",
  "item.minecraft.brown_dye": "Tinctura brunnea",
  "item.minecraft.brown_egg": "Ovum brunneum",
  "item.minecraft.brown_harness": "Capistrum brunneum",
  "item.minecraft.brush": "Peniculus",
  "item.minecraft.bucket": "Hama",
  "item.minecraft.bundle": "Sarcina",
  "item.minecraft.bundle.empty": "Vacua",
  "item.minecraft.bundle.empty.description": "Continet acervum rerum multorum generum",
  "item.minecraft.bundle.full": "Plena",
  "item.minecraft.bundle.fullness": "%s ex %s",
  "item.minecraft.burn_pottery_shard": "Testa cum igni picto",
  "item.minecraft.burn_pottery_sherd": "Testa cum igni picto",
  "item.minecraft.camel_husk_spawn_egg": "Ovum creationis cassi cameli",
  "item.minecraft.camel_spawn_egg": "Ovum creationis cameli",
  "item.minecraft.carrot": "Carota",
  "item.minecraft.carrot_on_a_stick": "Carota in virga",
  "item.minecraft.cat_spawn_egg": "Ovum creationis feles",
  "item.minecraft.cauldron": "Cortina",
  "item.minecraft.cave_spider_spawn_egg": "Ovum creationis araneae cavernae",
  "item.minecraft.chainmail_boots": "Caligae reticuli ferrei",
  "item.minecraft.chainmail_chestplate": "Lorica reticuli ferrei",
  "item.minecraft.chainmail_helmet": "Galea reticuli ferrei",
  "item.minecraft.chainmail_leggings": "Ocreae reticuli ferrei",
  "item.minecraft.charcoal": "Carbo ex ligno",
  "item.minecraft.cherry_boat": "Ratis cerasi",
  "item.minecraft.cherry_chest_boat": "Ratis cerasi cum cista",
  "item.minecraft.chest_minecart": "Plaustrum fodinae cum cista",
  "item.minecraft.chicken": "Caro gallinacea cruda",
  "item.minecraft.chicken_spawn_egg": "Ovum creationis pulli",
  "item.minecraft.chorus_fruit": "Pomus chori",
  "item.minecraft.clay_ball": "Pila argillae",
  "item.minecraft.clock": "Horologium",
  "item.minecraft.coal": "Carbo",
  "item.minecraft.coast_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ornamentum tegminis litorale",
  "item.minecraft.cocoa_beans": "Fabae theobromatis",
  "item.minecraft.cod": "Morua cruda",
  "item.minecraft.cod_bucket": "Hama cum morua",
  "item.minecraft.cod_spawn_egg": "Ovum creationis moruae",
  "item.minecraft.command_block_minecart": "Plaustrum fodinae cum cubo iussorum",
  "item.minecraft.compass": "Acus magnetica",
  "item.minecraft.cooked_beef": "Bubula cocta",
  "item.minecraft.cooked_chicken": "Caro gallinacea cocta",
  "item.minecraft.cooked_cod": "Morua cocta",
  "item.minecraft.cooked_mutton": "Agnina cocta",
  "item.minecraft.cooked_porkchop": "Suilla cocta",
  "item.minecraft.cooked_rabbit": "Caro cuniculi cocta",
  "item.minecraft.cooked_salmon": "Salmo coctus",
  "item.minecraft.cookie": "Crustulum",
  "item.minecraft.copper_axe": "Securis cuprea",
  "item.minecraft.copper_boots": "Caligae cupreae",
  "item.minecraft.copper_chestplate": "Lorica cuprea",
  "item.minecraft.copper_golem_spawn_egg": "Ovum creationis automati cuprei",
  "item.minecraft.copper_helmet": "Galea cuprea",
  "item.minecraft.copper_hoe": "Sarculum cupreum",
  "item.minecraft.copper_horse_armor": "Tegimen equinum cupreum",
  "item.minecraft.copper_ingot": "Later cupreus",
  "item.minecraft.copper_leggings": "Ocreae cupreae",
  "item.minecraft.copper_nautilus_armor": "Tegimen nautili cupreum",
  "item.minecraft.copper_nugget": "Massa cuprea",
  "item.minecraft.copper_pickaxe": "Dolabra cuprea",
  "item.minecraft.copper_shovel": "Pala cuprea",
  "item.minecraft.copper_spear": "Hasta cuprea",
  "item.minecraft.copper_sword": "Gladius cupreus",
  "item.minecraft.cow_spawn_egg": "Ovum creationis vaccae",
  "item.minecraft.creaking_spawn_egg": "Ovum creationis crepacis",
  "item.minecraft.creeper_banner_pattern": "Exemplar vexilli",
  "item.minecraft.creeper_banner_pattern.desc": "Imago creeper",
  "item.minecraft.creeper_banner_pattern.new": "Imago creeper exemplar vexilli",
  "item.minecraft.creeper_spawn_egg": "Ovum creationis creeper",
  "item.minecraft.crossbow": "Manuballista",
  "item.minecraft.crossbow.projectile": "Iaculum:",
  "item.minecraft.crossbow.projectile.multiple": "Iaculum: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Iaculum: %s",
  "item.minecraft.cyan_bundle": "Sarcina cyanea",
  "item.minecraft.cyan_dye": "Tinctura cyanea",
  "item.minecraft.cyan_harness": "Capistrum cyaneum",
  "item.minecraft.danger_pottery_shard": "Testa cum periculo picto",
  "item.minecraft.danger_pottery_sherd": "Testa cum periculo picto",
  "item.minecraft.dark_oak_boat": "Ratis quercus nigrae",
  "item.minecraft.dark_oak_chest_boat": "Ratis quercus nigrae cum cista",
  "item.minecraft.debug_stick": "Virga emendandi",
  "item.minecraft.debug_stick.empty": "%s nulla adiuncta habet",
  "item.minecraft.debug_stick.select": "\"%s\" selectus est (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ad %s",
  "item.minecraft.diamond": "Adamas",
  "item.minecraft.diamond_axe": "Securis adamantina",
  "item.minecraft.diamond_boots": "Caligae adamantinae",
  "item.minecraft.diamond_chestplate": "Lorica adamantina",
  "item.minecraft.diamond_helmet": "Galea adamantina",
  "item.minecraft.diamond_hoe": "Sarculum adamantinum",
  "item.minecraft.diamond_horse_armor": "Tegimen equinum adamantinum",
  "item.minecraft.diamond_leggings": "Ocreae adamantinae",
  "item.minecraft.diamond_nautilus_armor": "Tegimen natuili adamantinum",
  "item.minecraft.diamond_pickaxe": "Dolabra adamantina",
  "item.minecraft.diamond_shovel": "Pala adamantina",
  "item.minecraft.diamond_spear": "Hasta adamantina",
  "item.minecraft.diamond_sword": "Gladius adamantinus",
  "item.minecraft.disc_fragment_5": "Fragmentum phonodisci",
  "item.minecraft.disc_fragment_5.desc": "Phonodiscus - 5",
  "item.minecraft.dolphin_spawn_egg": "Ovum creationis delphini",
  "item.minecraft.donkey_spawn_egg": "Ovum creationis asini",
  "item.minecraft.dragon_breath": "Halitus draconis",
  "item.minecraft.dried_kelp": "Alga sicca",
  "item.minecraft.drowned_spawn_egg": "Ovum creationis mersi",
  "item.minecraft.dune_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ornamentum tegminis deserticum",
  "item.minecraft.echo_shard": "Fragmentum resonans",
  "item.minecraft.egg": "Ovum",
  "item.minecraft.elder_guardian_spawn_egg": "Ovum creationis custodis postnati",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Smaragdus",
  "item.minecraft.enchanted_book": "Liber incantatus",
  "item.minecraft.enchanted_golden_apple": "Malum aureum incantatum",
  "item.minecraft.end_crystal": "Crystallum End",
  "item.minecraft.ender_dragon_spawn_egg": "Ovum creationi draconis Ender",
  "item.minecraft.ender_eye": "Ender oculus",
  "item.minecraft.ender_pearl": "Margarita Ender",
  "item.minecraft.enderman_spawn_egg": "Ovum creationis enderman",
  "item.minecraft.endermite_spawn_egg": "Ovum creationis endermite",
  "item.minecraft.evoker_spawn_egg": "Ovum creationis evocatoris",
  "item.minecraft.experience_bottle": "Uter incantandi",
  "item.minecraft.explorer_pottery_shard": "Testa cum itinere picto",
  "item.minecraft.explorer_pottery_sherd": "Testa cum itinere picto",
  "item.minecraft.eye_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ornamentum tegminis cum oculo",
  "item.minecraft.feather": "Penna",
  "item.minecraft.fermented_spider_eye": "Oculus araneae fermentatus",
  "item.minecraft.field_masoned_banner_pattern": "Ager testaceus exemplar vexilli",
  "item.minecraft.filled_map": "Charta",
  "item.minecraft.fire_charge": "Missile igneum",
  "item.minecraft.firework_rocket": "Missile pyrotechnicum",
  "item.minecraft.firework_rocket.flight": "Tempus volatus:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Nucleus pyrotechnicus",
  "item.minecraft.firework_star.black": "Nigra",
  "item.minecraft.firework_star.blue": "Caerulea",
  "item.minecraft.firework_star.brown": "Brunnea",
  "item.minecraft.firework_star.custom_color": "Proprii coloris",
  "item.minecraft.firework_star.cyan": "Cyanea",
  "item.minecraft.firework_star.fade_to": "Quae fit",
  "item.minecraft.firework_star.flicker": "Corusca",
  "item.minecraft.firework_star.gray": "Cinerea",
  "item.minecraft.firework_star.green": "Viridis",
  "item.minecraft.firework_star.light_blue": "Aeria",
  "item.minecraft.firework_star.light_gray": "Cana",
  "item.minecraft.firework_star.lime": "Prasina",
  "item.minecraft.firework_star.magenta": "Rubropurpurea",
  "item.minecraft.firework_star.orange": "Aurantia",
  "item.minecraft.firework_star.pink": "Rosea",
  "item.minecraft.firework_star.purple": "Purpurea",
  "item.minecraft.firework_star.red": "Rubra",
  "item.minecraft.firework_star.shape": "Figura ignota",
  "item.minecraft.firework_star.shape.burst": "Eruptio",
  "item.minecraft.firework_star.shape.creeper": "Forma creeper",
  "item.minecraft.firework_star.shape.large_ball": "Pila maior",
  "item.minecraft.firework_star.shape.small_ball": "Pila minor",
  "item.minecraft.firework_star.shape.star": "Forma stellae",
  "item.minecraft.firework_star.trail": "Cum sulco",
  "item.minecraft.firework_star.white": "Alba",
  "item.minecraft.firework_star.yellow": "Flava",
  "item.minecraft.fishing_rod": "Harundo",
  "item.minecraft.flint": "Silex",
  "item.minecraft.flint_and_steel": "Ignitabulum",
  "item.minecraft.flow_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ornamentum tegminis cum fluxu",
  "item.minecraft.flow_banner_pattern": "Exemplar vexilli",
  "item.minecraft.flow_banner_pattern.desc": "Fluxus",
  "item.minecraft.flow_banner_pattern.new": "Fluxus exemplar vexilli",
  "item.minecraft.flow_pottery_sherd": "Testa cum fluxo picta",
  "item.minecraft.flower_banner_pattern": "Exemplar vexilli",
  "item.minecraft.flower_banner_pattern.desc": "Imago floris",
  "item.minecraft.flower_banner_pattern.new": "Imago floris exemplar vexilli",
  "item.minecraft.flower_pot": "Vas",
  "item.minecraft.fox_spawn_egg": "Ovum creationis vulpis",
  "item.minecraft.friend_pottery_shard": "Testa cum amico picto",
  "item.minecraft.friend_pottery_sherd": "Testa cum amico picto",
  "item.minecraft.frog_spawn_egg": "Ovum creationis ranae",
  "item.minecraft.furnace_minecart": "Plaustrum fodinae cum fornace",
  "item.minecraft.ghast_spawn_egg": "Ovum creationis ghast",
  "item.minecraft.ghast_tear": "Lacrima ghast",
  "item.minecraft.glass_bottle": "Uter vitrei",
  "item.minecraft.glistering_melon_slice": "Sectio peponis fulgens",
  "item.minecraft.globe_banner_pattern": "Exemplar vexilli",
  "item.minecraft.globe_banner_pattern.desc": "Globus",
  "item.minecraft.globe_banner_pattern.new": "Globus exemplar vexilli",
  "item.minecraft.glow_berries": "Bacae lucidae",
  "item.minecraft.glow_ink_sac": "Saccus atramenti lucidi",
  "item.minecraft.glow_item_frame": "Forma reris lucida",
  "item.minecraft.glow_squid_spawn_egg": "Ovum creationis lolliginis lucidae",
  "item.minecraft.glowstone_dust": "Pulvis lucilapideus",
  "item.minecraft.goat_horn": "Cornu caprae",
  "item.minecraft.goat_spawn_egg": "Ovum creationis caprae",
  "item.minecraft.gold_ingot": "Later aurea",
  "item.minecraft.gold_nugget": "Massa aurea",
  "item.minecraft.golden_apple": "Malum aureum",
  "item.minecraft.golden_axe": "Securis aurea",
  "item.minecraft.golden_boots": "Caligae aureae",
  "item.minecraft.golden_carrot": "Carota aurea",
  "item.minecraft.golden_chestplate": "Lorica aurea",
  "item.minecraft.golden_helmet": "Galea aurea",
  "item.minecraft.golden_hoe": "Sarculum aureum",
  "item.minecraft.golden_horse_armor": "Tegimen equinum aureum",
  "item.minecraft.golden_leggings": "Ocreae aureae",
  "item.minecraft.golden_nautilus_armor": "Tegimen nautili aureum",
  "item.minecraft.golden_pickaxe": "Dolabra aurea",
  "item.minecraft.golden_shovel": "Pala aurea",
  "item.minecraft.golden_spear": "Hasta aurea",
  "item.minecraft.golden_sword": "Gladius aureus",
  "item.minecraft.gray_bundle": "Sarcina cinerea",
  "item.minecraft.gray_dye": "Tinctura cinerea",
  "item.minecraft.gray_harness": "Capistrum cinereum",
  "item.minecraft.green_bundle": "Sarcina viridis",
  "item.minecraft.green_dye": "Tinctura viridis",
  "item.minecraft.green_harness": "Capistrum viride",
  "item.minecraft.guardian_spawn_egg": "Ovum creationis custodis",
  "item.minecraft.gunpowder": "Pulvis pyrius",
  "item.minecraft.guster_banner_pattern": "Exemplar vexilli",
  "item.minecraft.guster_banner_pattern.desc": "Ventifer",
  "item.minecraft.guster_banner_pattern.new": "Ventifer exemplar vexilli",
  "item.minecraft.guster_pottery_sherd": "Testa cum ventifero picto",
  "item.minecraft.happy_ghast_spawn_egg": "Ovum creationis ghast laeti",
  "item.minecraft.harness": "Capistrum",
  "item.minecraft.heart_of_the_sea": "Cor maris",
  "item.minecraft.heart_pottery_shard": "Testa cum corde picto",
  "item.minecraft.heart_pottery_sherd": "Testa cum corde picto",
  "item.minecraft.heartbreak_pottery_shard": "Testa cum corde fracto picto",
  "item.minecraft.heartbreak_pottery_sherd": "Testa cum corde fracto picto",
  "item.minecraft.hoglin_spawn_egg": "Ovum creationis hoglin",
  "item.minecraft.honey_bottle": "Uter mellis",
  "item.minecraft.honeycomb": "Favus",
  "item.minecraft.hopper_minecart": "Plaustrum fodinae cum infundibulo",
  "item.minecraft.horse_spawn_egg": "Ovum creationis equi",
  "item.minecraft.host_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ornamentum tegminis hospitis",
  "item.minecraft.howl_pottery_shard": "Testa cum lupa picta",
  "item.minecraft.howl_pottery_sherd": "Testa cum lupa picta",
  "item.minecraft.husk_spawn_egg": "Ovum creationis cassi",
  "item.minecraft.ink_sac": "Saccus atramenti",
  "item.minecraft.iron_axe": "Securis ferrea",
  "item.minecraft.iron_boots": "Caligae ferreae",
  "item.minecraft.iron_chestplate": "Lorica ferrea",
  "item.minecraft.iron_golem_spawn_egg": "Ovum creationis automati ferrei",
  "item.minecraft.iron_helmet": "Galea ferrea",
  "item.minecraft.iron_hoe": "Sarculum Ferreum",
  "item.minecraft.iron_horse_armor": "Tegimen equinum ferreum",
  "item.minecraft.iron_ingot": "Later ferreus",
  "item.minecraft.iron_leggings": "Ocreae ferreae",
  "item.minecraft.iron_nautilus_armor": "Tegimen nautili ferreum",
  "item.minecraft.iron_nugget": "Massa ferrea",
  "item.minecraft.iron_pickaxe": "Dolabra ferrea",
  "item.minecraft.iron_shovel": "Pala ferrea",
  "item.minecraft.iron_spear": "Hasta ferrea",
  "item.minecraft.iron_sword": "Gladius ferreus",
  "item.minecraft.item_frame": "Forma rerum",
  "item.minecraft.jungle_boat": "Ratis theobromatis",
  "item.minecraft.jungle_chest_boat": "Ratis theobromatis cum cista",
  "item.minecraft.knowledge_book": "Liber scientiae",
  "item.minecraft.lapis_lazuli": "Lapis lazuli",
  "item.minecraft.lava_bucket": "Hama lavae",
  "item.minecraft.lead": "Copula",
  "item.minecraft.leather": "Corium",
  "item.minecraft.leather_boots": "Calcei scortei",
  "item.minecraft.leather_chestplate": "Tunica scortea",
  "item.minecraft.leather_helmet": "Pileus scorteus",
  "item.minecraft.leather_horse_armor": "Tegimen equinum scorteum",
  "item.minecraft.leather_leggings": "Bracae scorteae",
  "item.minecraft.light_blue_bundle": "Sarcina aeria",
  "item.minecraft.light_blue_dye": "Tinctura aeria",
  "item.minecraft.light_blue_harness": "Capistrum aerium",
  "item.minecraft.light_gray_bundle": "Sarcina cana",
  "item.minecraft.light_gray_dye": "Tinctura cana",
  "item.minecraft.light_gray_harness": "Capistrum canum",
  "item.minecraft.lime_bundle": "Sarcina prasina",
  "item.minecraft.lime_dye": "Tinctura prasina",
  "item.minecraft.lime_harness": "Capistrum prasinum",
  "item.minecraft.lingering_potion": "Potio commorans",
  "item.minecraft.lingering_potion.effect.awkward": "Potio inconcinna commorans",
  "item.minecraft.lingering_potion.effect.empty": "Potio infabricabilis commorans",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Potio resistentiae igni commorans",
  "item.minecraft.lingering_potion.effect.harming": "Potio calamitatis commorans",
  "item.minecraft.lingering_potion.effect.healing": "Potio curationis commorans",
  "item.minecraft.lingering_potion.effect.infested": "Potio infestationis commorans",
  "item.minecraft.lingering_potion.effect.invisibility": "Potio invisibilitatis commorans",
  "item.minecraft.lingering_potion.effect.leaping": "Potio saltantis commorans",
  "item.minecraft.lingering_potion.effect.levitation": "Potio evectionis commorans",
  "item.minecraft.lingering_potion.effect.luck": "Potio fortunae commorans",
  "item.minecraft.lingering_potion.effect.mundane": "Potio mundana commorans",
  "item.minecraft.lingering_potion.effect.night_vision": "Potio visionis nocturnae commorans",
  "item.minecraft.lingering_potion.effect.oozing": "Potio manationis commorans",
  "item.minecraft.lingering_potion.effect.poison": "Potio veneni commorans",
  "item.minecraft.lingering_potion.effect.regeneration": "Potio regenerationis commorans",
  "item.minecraft.lingering_potion.effect.slow_falling": "Potio casus lenti commorans",
  "item.minecraft.lingering_potion.effect.slowness": "Potio tarditatis commorans",
  "item.minecraft.lingering_potion.effect.strength": "Potio fortitudinis commorans",
  "item.minecraft.lingering_potion.effect.swiftness": "Potio velocitatis commorans",
  "item.minecraft.lingering_potion.effect.thick": "Potio crassa commorans",
  "item.minecraft.lingering_potion.effect.turtle_master": "Potio magistri testudinis commorans",
  "item.minecraft.lingering_potion.effect.water": "Uter aquae commorans",
  "item.minecraft.lingering_potion.effect.water_breathing": "Potio respirationis in aqua commorans",
  "item.minecraft.lingering_potion.effect.weakness": "Potio infirmitatis commorans",
  "item.minecraft.lingering_potion.effect.weaving": "Potio contextus commorans",
  "item.minecraft.lingering_potion.effect.wind_charged": "Potio inflationis commorans",
  "item.minecraft.llama_spawn_egg": "Ovum creationis lamae",
  "item.minecraft.lodestone_compass": "Acus magnetica vi magnetica imbuta",
  "item.minecraft.mace": "Clava ferrea",
  "item.minecraft.magenta_bundle": "Sarcina rubropurpurea",
  "item.minecraft.magenta_dye": "Tinctura rubropurpurea",
  "item.minecraft.magenta_harness": "Capistrum rubropurpureum",
  "item.minecraft.magma_cream": "Massa magmatis",
  "item.minecraft.magma_cube_spawn_egg": "Ovum creationis cubi magmatis",
  "item.minecraft.mangrove_boat": "Ratis manglis",
  "item.minecraft.mangrove_chest_boat": "Ratis manglis cum cista",
  "item.minecraft.map": "Charta inanis",
  "item.minecraft.melon_seeds": "Semina peponis",
  "item.minecraft.melon_slice": "Sectio peponis",
  "item.minecraft.milk_bucket": "Hama lactis",
  "item.minecraft.minecart": "Plaustrum fodinae",
  "item.minecraft.miner_pottery_shard": "Testa cum dolabra picta",
  "item.minecraft.miner_pottery_sherd": "Testa cum dolabra picta",
  "item.minecraft.mojang_banner_pattern": "Exemplar vexilli",
  "item.minecraft.mojang_banner_pattern.desc": "Res",
  "item.minecraft.mojang_banner_pattern.new": "Res exemplar vexilli",
  "item.minecraft.mooshroom_spawn_egg": "Ovum creationis mooshroom",
  "item.minecraft.mourner_pottery_shard": "Testa cum luctu picto",
  "item.minecraft.mourner_pottery_sherd": "Testa cum luctu picto",
  "item.minecraft.mule_spawn_egg": "Ovum creationis muli",
  "item.minecraft.mushroom_stew": "Ius funginum",
  "item.minecraft.music_disc_11": "Phonodiscus",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Phonodiscus",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Phonodiscus",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Phonodiscus",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Phonodiscus",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Phonodiscus",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Phonodiscus",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Phonodiscus",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (campanulae)",
  "item.minecraft.music_disc_far": "Phonodiscus",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Phonodiscus",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Phonodiscus",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Phonodiscus",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Phonodiscus",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Phonodiscus",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Phonodiscus",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Phonodiscus",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Phonodiscus",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Phonodiscus",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Phonodiscus",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Phonodiscus",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Phonodiscus",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Agnina cruda",
  "item.minecraft.name_tag": "Nota nominis",
  "item.minecraft.nautilus_shell": "Concha nautili",
  "item.minecraft.nautilus_spawn_egg": "Ovum creationis nautili",
  "item.minecraft.nether_brick": "Later Nether",
  "item.minecraft.nether_star": "Stella Nether",
  "item.minecraft.nether_wart": "Verruca Nether",
  "item.minecraft.netherite_axe": "Securis Netheritae",
  "item.minecraft.netherite_boots": "Caligae Netheritae",
  "item.minecraft.netherite_chestplate": "Lorica Netheritae",
  "item.minecraft.netherite_helmet": "Galea Netheritae",
  "item.minecraft.netherite_hoe": "Sarculum Netheritae",
  "item.minecraft.netherite_horse_armor": "Tegimen equinum Netheritae",
  "item.minecraft.netherite_ingot": "Later Netheritae",
  "item.minecraft.netherite_leggings": "Ocreae Netheritae",
  "item.minecraft.netherite_nautilus_armor": "Tegimen nautili Netheritae",
  "item.minecraft.netherite_pickaxe": "Dolabra Netheritae",
  "item.minecraft.netherite_scrap": "Frustum Netheritae",
  "item.minecraft.netherite_shovel": "Pala Netheritae",
  "item.minecraft.netherite_spear": "Hasta Netheritae",
  "item.minecraft.netherite_sword": "Gladius Netheritae",
  "item.minecraft.netherite_upgrade_smithing_template": "Forma fabrilis",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Solidamentum ex Netherite",
  "item.minecraft.oak_boat": "Ratis quercea",
  "item.minecraft.oak_chest_boat": "Ratis quercea cum cista",
  "item.minecraft.ocelot_spawn_egg": "Ovum creationis pardi",
  "item.minecraft.ominous_bottle": "Uter praesagus",
  "item.minecraft.ominous_trial_key": "Clavis periculorum praesaga",
  "item.minecraft.orange_bundle": "Sarcina aurantia",
  "item.minecraft.orange_dye": "Tinctura aurantia",
  "item.minecraft.orange_harness": "Capistrum aurantium",
  "item.minecraft.painting": "Pictura",
  "item.minecraft.pale_oak_boat": "Ratis quercus pallidae",
  "item.minecraft.pale_oak_chest_boat": "Ratis quercus pallidae cum cista",
  "item.minecraft.panda_spawn_egg": "Ovum creationis pandae",
  "item.minecraft.paper": "Papyrus",
  "item.minecraft.parched_spawn_egg": "Ovum creationis torridi",
  "item.minecraft.parrot_spawn_egg": "Ovum creationis psittaci",
  "item.minecraft.phantom_membrane": "Membrana phantasmatis",
  "item.minecraft.phantom_spawn_egg": "Ovum creationis phantasmatis",
  "item.minecraft.pig_spawn_egg": "Ovum creationis suis",
  "item.minecraft.piglin_banner_pattern": "Exemplar vexilli",
  "item.minecraft.piglin_banner_pattern.desc": "Rostrum",
  "item.minecraft.piglin_banner_pattern.new": "Rostrum exemplar vexilli",
  "item.minecraft.piglin_brute_spawn_egg": "Ovum creationis piglin feri",
  "item.minecraft.piglin_spawn_egg": "Ovum creationis piglin",
  "item.minecraft.pillager_spawn_egg": "Ovum creationis praedatoris",
  "item.minecraft.pink_bundle": "Sarcina rosea",
  "item.minecraft.pink_dye": "Tinctura rosea",
  "item.minecraft.pink_harness": "Capistrum roseum",
  "item.minecraft.pitcher_plant": "Nepenthes",
  "item.minecraft.pitcher_pod": "Nepenthis siliqua",
  "item.minecraft.plenty_pottery_shard": "Testa cum copia picta",
  "item.minecraft.plenty_pottery_sherd": "Testa cum copia picta",
  "item.minecraft.poisonous_potato": "Patata venenata",
  "item.minecraft.polar_bear_spawn_egg": "Ovum creationis ursi polaris",
  "item.minecraft.popped_chorus_fruit": "Pomus chori displosus",
  "item.minecraft.porkchop": "Suilla cruda",
  "item.minecraft.potato": "Patata",
  "item.minecraft.potion": "Potio",
  "item.minecraft.potion.effect.awkward": "Potio inconcinna",
  "item.minecraft.potion.effect.empty": "Potio infabricabilis",
  "item.minecraft.potion.effect.fire_resistance": "Potio resistentiae igni",
  "item.minecraft.potion.effect.harming": "Potio calamitatis",
  "item.minecraft.potion.effect.healing": "Potio curationis",
  "item.minecraft.potion.effect.infested": "Potio infestationis",
  "item.minecraft.potion.effect.invisibility": "Potio invisibilitatis",
  "item.minecraft.potion.effect.leaping": "Potio saltantis",
  "item.minecraft.potion.effect.levitation": "Potio evectionis",
  "item.minecraft.potion.effect.luck": "Potio fortunae",
  "item.minecraft.potion.effect.mundane": "Potio mundana",
  "item.minecraft.potion.effect.night_vision": "Potio visionis nocturnae",
  "item.minecraft.potion.effect.oozing": "Potio manationis",
  "item.minecraft.potion.effect.poison": "Potio veneni",
  "item.minecraft.potion.effect.regeneration": "Potio regenerationis",
  "item.minecraft.potion.effect.slow_falling": "Potio casus lenti",
  "item.minecraft.potion.effect.slowness": "Potio tarditatis",
  "item.minecraft.potion.effect.strength": "Potio fortitudinis",
  "item.minecraft.potion.effect.swiftness": "Potio velocitatis",
  "item.minecraft.potion.effect.thick": "Potio crassa",
  "item.minecraft.potion.effect.turtle_master": "Potio magistri testudinis",
  "item.minecraft.potion.effect.water": "Uter aquae",
  "item.minecraft.potion.effect.water_breathing": "Potio respirationis in aqua",
  "item.minecraft.potion.effect.weakness": "Potio infirmitatis",
  "item.minecraft.potion.effect.weaving": "Potio contextus",
  "item.minecraft.potion.effect.wind_charged": "Potio inflationis",
  "item.minecraft.pottery_shard_archer": "Testa cum arco picta",
  "item.minecraft.pottery_shard_arms_up": "Testa cum brachiis pictis",
  "item.minecraft.pottery_shard_prize": "Testa cum adamante picto",
  "item.minecraft.pottery_shard_skull": "Testa cum calva picta",
  "item.minecraft.powder_snow_bucket": "Hama nivis pulvereae",
  "item.minecraft.prismarine_crystals": "Crystalla prismarinae",
  "item.minecraft.prismarine_shard": "Fragmentum prismarinum",
  "item.minecraft.prize_pottery_shard": "Testa cum adamante picto",
  "item.minecraft.prize_pottery_sherd": "Testa cum adamante picto",
  "item.minecraft.pufferfish": "Piscis aculeatus",
  "item.minecraft.pufferfish_bucket": "Hama cum pisce aculeato",
  "item.minecraft.pufferfish_spawn_egg": "Ovum creationis piscis aculeati",
  "item.minecraft.pumpkin_pie": "Placenta cucurbitae",
  "item.minecraft.pumpkin_seeds": "Semina cucurbitae",
  "item.minecraft.purple_bundle": "Sarcina purpurea",
  "item.minecraft.purple_dye": "Tinctura purpurea",
  "item.minecraft.purple_harness": "Capistrum purpureum",
  "item.minecraft.quartz": "Crystallum Nether",
  "item.minecraft.rabbit": "Caro cuniculi cruda",
  "item.minecraft.rabbit_foot": "Pes cuniculi",
  "item.minecraft.rabbit_hide": "Pellis cunicularis",
  "item.minecraft.rabbit_spawn_egg": "Ovum creationis cuniculi",
  "item.minecraft.rabbit_stew": "Ius de cuniculo",
  "item.minecraft.raiser_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ornamentum tegminis tollentis",
  "item.minecraft.ravager_spawn_egg": "Ovum creationis vastatoris",
  "item.minecraft.raw_copper": "Cuprum infectum",
  "item.minecraft.raw_gold": "Aurum infectum",
  "item.minecraft.raw_iron": "Ferrum infectum",
  "item.minecraft.recovery_compass": "Pyxis magnetica ad recuperandum",
  "item.minecraft.red_bundle": "Sarcina rubra",
  "item.minecraft.red_dye": "Tinctura rubra",
  "item.minecraft.red_harness": "Capistrum rubrum",
  "item.minecraft.redstone": "Pulvis redstone",
  "item.minecraft.resin_brick": "Later resinae",
  "item.minecraft.resin_clump": "Glaeba resinae",
  "item.minecraft.rib_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ornamentum tegminis cum costis",
  "item.minecraft.rotten_flesh": "Caro putris",
  "item.minecraft.saddle": "Sagma",
  "item.minecraft.salmon": "Salmo crudus",
  "item.minecraft.salmon_bucket": "Hama cum salmone",
  "item.minecraft.salmon_spawn_egg": "Ovum creationis salmonis",
  "item.minecraft.scrape_pottery_sherd": "Testa cum secure picta",
  "item.minecraft.scute": "Squama",
  "item.minecraft.sentry_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ornamentum tegminis excubitorum",
  "item.minecraft.shaper_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ornamentum tegminis fictoris",
  "item.minecraft.sheaf_pottery_shard": "Testa cum frumento picto",
  "item.minecraft.sheaf_pottery_sherd": "Testa cum frumento picto",
  "item.minecraft.shears": "Forfex",
  "item.minecraft.sheep_spawn_egg": "Ovum creationis ovis",
  "item.minecraft.shelter_pottery_shard": "Testa cum perfugio picto",
  "item.minecraft.shelter_pottery_sherd": "Testa cum perfugio picto",
  "item.minecraft.shield": "Scutum",
  "item.minecraft.shield.black": "Scutum nigrum",
  "item.minecraft.shield.blue": "Scutum caeruleum",
  "item.minecraft.shield.brown": "Scutum brunneum",
  "item.minecraft.shield.cyan": "Scutum cyaneum",
  "item.minecraft.shield.gray": "Scutum cinereum",
  "item.minecraft.shield.green": "Scutum viridis",
  "item.minecraft.shield.light_blue": "Scutum aerium",
  "item.minecraft.shield.light_gray": "Scutum canum",
  "item.minecraft.shield.lime": "Scutum prasinum",
  "item.minecraft.shield.magenta": "Scutum rubropurpureum",
  "item.minecraft.shield.orange": "Scutum aurantium",
  "item.minecraft.shield.pink": "Scutum roseum",
  "item.minecraft.shield.purple": "Scutum purpureum",
  "item.minecraft.shield.red": "Scutum rubrum",
  "item.minecraft.shield.white": "Scutum album",
  "item.minecraft.shield.yellow": "Scutum flavum",
  "item.minecraft.shulker_shell": "Concha shulker",
  "item.minecraft.shulker_spawn_egg": "Ovum creationis shulker",
  "item.minecraft.sign": "Titulus",
  "item.minecraft.silence_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ornamentum tegminis silentis",
  "item.minecraft.silverfish_spawn_egg": "Ovum creationis lepismatis",
  "item.minecraft.skeleton_horse_spawn_egg": "Ovum creationis equi sceletalis",
  "item.minecraft.skeleton_spawn_egg": "Ovum creationis sceleti",
  "item.minecraft.skull_banner_pattern": "Exemplar vexilli",
  "item.minecraft.skull_banner_pattern.desc": "Imago calvae",
  "item.minecraft.skull_banner_pattern.new": "Imago calvae exemplar vexilli",
  "item.minecraft.skull_pottery_shard": "Testa cum calva picta",
  "item.minecraft.skull_pottery_sherd": "Testa cum calva picta",
  "item.minecraft.slime_ball": "Pila muci",
  "item.minecraft.slime_spawn_egg": "Ovum creationis muci",
  "item.minecraft.smithing_template": "Forma fabrilis",
  "item.minecraft.smithing_template.applies_to": "Pertinet ad:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Adde laterem vel lapidem",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Tegmina",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Adde tegimen",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lateribus lapidibusve",
  "item.minecraft.smithing_template.ingredients": "Fabricatur cum:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Adde laterem Netheritae",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Arma vel instrumenta adamantina",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Adde telum, tegimen vel instrumentum adamantinum",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Latere Netheritae",
  "item.minecraft.smithing_template.upgrade": "Solidamentum: ",
  "item.minecraft.sniffer_spawn_egg": "Ovum creationis odorisequi",
  "item.minecraft.snort_pottery_shard": "Testa cum rostro picto",
  "item.minecraft.snort_pottery_sherd": "Testa cum rostro picto",
  "item.minecraft.snout_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ornamentum tegminis cum rostro",
  "item.minecraft.snow_golem_spawn_egg": "Ovum creationis automati nivei",
  "item.minecraft.snowball": "Pila nivis",
  "item.minecraft.spectral_arrow": "Sagitta lucifera",
  "item.minecraft.spider_eye": "Oculus araneae",
  "item.minecraft.spider_spawn_egg": "Ovum creationis araneae",
  "item.minecraft.spire_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ornamentum tegminis cum turre",
  "item.minecraft.splash_potion": "Potio aspergens",
  "item.minecraft.splash_potion.effect.awkward": "Potio inconcinna aspergens",
  "item.minecraft.splash_potion.effect.empty": "Potio infabricabilis aspergens",
  "item.minecraft.splash_potion.effect.fire_resistance": "Potio resistentiae igni aspergens",
  "item.minecraft.splash_potion.effect.harming": "Potio calamitatis aspergens",
  "item.minecraft.splash_potion.effect.healing": "Potio curationis aspergens",
  "item.minecraft.splash_potion.effect.infested": "Potio infestationis aspergens",
  "item.minecraft.splash_potion.effect.invisibility": "Potio invisibilitatis aspergens",
  "item.minecraft.splash_potion.effect.leaping": "Potio saltantis aspergens",
  "item.minecraft.splash_potion.effect.levitation": "Potio evectionis aspergens",
  "item.minecraft.splash_potion.effect.luck": "Potio fortunae aspergens",
  "item.minecraft.splash_potion.effect.mundane": "Potio mundana aspergens",
  "item.minecraft.splash_potion.effect.night_vision": "Potio visionis nocturnae aspergens",
  "item.minecraft.splash_potion.effect.oozing": "Potio manationis aspergens",
  "item.minecraft.splash_potion.effect.poison": "Potio veneni aspergens",
  "item.minecraft.splash_potion.effect.regeneration": "Potio regenerationis aspergens",
  "item.minecraft.splash_potion.effect.slow_falling": "Potio casus lenti aspergens",
  "item.minecraft.splash_potion.effect.slowness": "Potio tarditatis aspergens",
  "item.minecraft.splash_potion.effect.strength": "Potio fortitudinis aspergens",
  "item.minecraft.splash_potion.effect.swiftness": "Potio velocitatis aspergens",
  "item.minecraft.splash_potion.effect.thick": "Potio crassa aspergens",
  "item.minecraft.splash_potion.effect.turtle_master": "Potio magistri testudinis aspergens",
  "item.minecraft.splash_potion.effect.water": "Uter aquae aspergens",
  "item.minecraft.splash_potion.effect.water_breathing": "Potio respirationis in aqua aspergens",
  "item.minecraft.splash_potion.effect.weakness": "Potio infirmitatis aspergens",
  "item.minecraft.splash_potion.effect.weaving": "Potio contextus aspergens",
  "item.minecraft.splash_potion.effect.wind_charged": "Potio inflationis aspergens",
  "item.minecraft.spruce_boat": "Ratis piceae",
  "item.minecraft.spruce_chest_boat": "Ratis piceae cum cista",
  "item.minecraft.spyglass": "Telescopium",
  "item.minecraft.squid_spawn_egg": "Ovum creationis lolliginis",
  "item.minecraft.stick": "Virga",
  "item.minecraft.stone_axe": "Securis saxeus",
  "item.minecraft.stone_hoe": "Sarculum saxeum",
  "item.minecraft.stone_pickaxe": "Dolabra saxea",
  "item.minecraft.stone_shovel": "Pala saxea",
  "item.minecraft.stone_spear": "Hasta saxea",
  "item.minecraft.stone_sword": "Gladius saxeus",
  "item.minecraft.stray_spawn_egg": "Ovum creationis aberratoris",
  "item.minecraft.strider_spawn_egg": "Ovum creationis ambulatoris",
  "item.minecraft.string": "Filum",
  "item.minecraft.sugar": "Saccharum",
  "item.minecraft.suspicious_stew": "Ius suspectum",
  "item.minecraft.sweet_berries": "Bacae dulces",
  "item.minecraft.tadpole_bucket": "Hama cum gyrino",
  "item.minecraft.tadpole_spawn_egg": "Ovum creationis gyrini",
  "item.minecraft.tide_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ornamentum tegminis cum aestu",
  "item.minecraft.tipped_arrow": "Sagitta imbuta",
  "item.minecraft.tipped_arrow.effect.awkward": "Sagitta imbuta",
  "item.minecraft.tipped_arrow.effect.empty": "Sagitta imbuta infabricabilis",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Sagitta resistentiae igni",
  "item.minecraft.tipped_arrow.effect.harming": "Sagitta calamitatis",
  "item.minecraft.tipped_arrow.effect.healing": "Sagitta curationis",
  "item.minecraft.tipped_arrow.effect.infested": "Sagitta infestationis",
  "item.minecraft.tipped_arrow.effect.invisibility": "Sagitta invisibilitatis",
  "item.minecraft.tipped_arrow.effect.leaping": "Sagitta saltantis",
  "item.minecraft.tipped_arrow.effect.levitation": "Sagitta evectionis",
  "item.minecraft.tipped_arrow.effect.luck": "Sagitta fortunae",
  "item.minecraft.tipped_arrow.effect.mundane": "Sagitta imbuta",
  "item.minecraft.tipped_arrow.effect.night_vision": "Sagitta visionis nocturnae",
  "item.minecraft.tipped_arrow.effect.oozing": "Sagitta manationis",
  "item.minecraft.tipped_arrow.effect.poison": "Sagitta veneni",
  "item.minecraft.tipped_arrow.effect.regeneration": "Sagitta regenerationis",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Sagitta casus lenti",
  "item.minecraft.tipped_arrow.effect.slowness": "Sagitta tarditatis",
  "item.minecraft.tipped_arrow.effect.strength": "Sagitta fortitudinis",
  "item.minecraft.tipped_arrow.effect.swiftness": "Sagitta velocitatis",
  "item.minecraft.tipped_arrow.effect.thick": "Sagitta imbuta",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Sagitta magistri testudinis",
  "item.minecraft.tipped_arrow.effect.water": "Sagitta aspergentis",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Sagitta respirationis in aqua",
  "item.minecraft.tipped_arrow.effect.weakness": "Sagitta infirmitatis",
  "item.minecraft.tipped_arrow.effect.weaving": "Sagitta contextus",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Sagitta inflationis",
  "item.minecraft.tnt_minecart": "Plaustrum fodinae cum dynamite",
  "item.minecraft.torchflower_seeds": "Semina faculariae",
  "item.minecraft.totem_of_undying": "Simulacrum immortalitatis",
  "item.minecraft.trader_llama_spawn_egg": "Ovum creationis lamae mercatoris",
  "item.minecraft.trial_key": "Clavis periculorum",
  "item.minecraft.trident": "Tridens",
  "item.minecraft.tropical_fish": "Piscis multigener",
  "item.minecraft.tropical_fish_bucket": "Hama cum pisce multigeneri",
  "item.minecraft.tropical_fish_spawn_egg": "Ovum creationis piscis multigeneris",
  "item.minecraft.turtle_helmet": "Testa testudinis",
  "item.minecraft.turtle_scute": "Squama testudinis",
  "item.minecraft.turtle_spawn_egg": "Ovum creationis testudinis",
  "item.minecraft.vex_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ornamentum tegminis vexatoris",
  "item.minecraft.vex_spawn_egg": "Ovum creationis vexatoris",
  "item.minecraft.villager_spawn_egg": "Ovum creationis vicani",
  "item.minecraft.vindicator_spawn_egg": "Ovum creationis vindicatoris",
  "item.minecraft.wandering_trader_spawn_egg": "Ovum creationis mercatoris vagi",
  "item.minecraft.ward_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ornamentum tegminis vigiliarum",
  "item.minecraft.warden_spawn_egg": "Ovum creationis vigilis",
  "item.minecraft.warped_fungus_on_a_stick": "Fungus distortus in virga",
  "item.minecraft.water_bucket": "Hama aquae",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ornamentum tegminis viatoris",
  "item.minecraft.wheat": "Frumentum",
  "item.minecraft.wheat_seeds": "Semina frumenti",
  "item.minecraft.white_bundle": "Sarcina alba",
  "item.minecraft.white_dye": "Tinctura alba",
  "item.minecraft.white_harness": "Capistrum album",
  "item.minecraft.wild_armor_trim_smithing_template": "Forma fabrilis",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ornamentum tegminis silvanum",
  "item.minecraft.wind_charge": "Missile ventosum",
  "item.minecraft.witch_spawn_egg": "Ovum creationis veneficae",
  "item.minecraft.wither_skeleton_spawn_egg": "Ovum creationis sceleti wither",
  "item.minecraft.wither_spawn_egg": "Ovum creationis wither",
  "item.minecraft.wolf_armor": "Tegmen lupinum",
  "item.minecraft.wolf_spawn_egg": "Ovum creationis lupi",
  "item.minecraft.wooden_axe": "Securis lignea",
  "item.minecraft.wooden_hoe": "Sarculum ligneum",
  "item.minecraft.wooden_pickaxe": "Dolabra lignea",
  "item.minecraft.wooden_shovel": "Pala lignea",
  "item.minecraft.wooden_spear": "Hasta lignea",
  "item.minecraft.wooden_sword": "Gladius ligneus",
  "item.minecraft.writable_book": "Liber et penna",
  "item.minecraft.written_book": "Liber inscriptus",
  "item.minecraft.yellow_bundle": "Sarcina flava",
  "item.minecraft.yellow_dye": "Tinctura flava",
  "item.minecraft.yellow_harness": "Capistrum flavum",
  "item.minecraft.zoglin_spawn_egg": "Ovum creationis zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ovum creationis equi resurrecti",
  "item.minecraft.zombie_nautilus_spawn_egg": "Ovum creationis nautili resurrecti",
  "item.minecraft.zombie_spawn_egg": "Ovum creationis resurrecti",
  "item.minecraft.zombie_villager_spawn_egg": "Ovum creationis vicani resurrecti",
  "item.minecraft.zombified_piglin_spawn_egg": "Ovum creationis piglin resurrecti"
}
export const la_la = items; 
